<template>
  <b-container class="mw-100 mt-3 mb-2">
    <b-card no-body>
      <validation-observer ref="mainForm" v-slot="{ invalid }">
        <b-tabs card v-model="currentTab" content-class="mb-0" ref="tabContainer">
          <b-tab :title="`${$tc('message.violationData', 1)}`">
            <b-container class="m-0 p-0 mw-100 mb-2">
              <transition :name="transitionName">
                <b-row v-show="tabs.violationData.index === currentTab && tabs.violationData.active">
                  <b-col>
                    <b-container class="mw-100 mt-2">
                      <b-row>
                        <b-col v-if="violationID" cols="12" sm="12" md="6" lg="4" xl="4">
                          <b-form-group :label="`${$tc('message.violationID', 1)} (*)`"
                                        label-for="input-violation-id">
                            <h5><b>{{ mainBody.violationData.id }}</b></h5>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                          <b-form-group :label="`${$tc('message.linkedViolationID', 1)}`"
                                        label-for="input-linked-violation-id">
                            <b-row>
                              <b-col cols="12" sm="12" md="10" lg="9" xl="9" style="padding-right: 0">
                                <model-list-select id="input-linked-violation-id"
                                                   option-text="text"
                                                   option-value="value"
                                                   v-on:input="onChangeLinkedViolation()"
                                                   :placeholder="violationOptions && violationOptions.length
                                             !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                                   v-model="mainBody.violationData.idViolazioneCollegata"
                                                   :list="violationOptions">
                                </model-list-select>
                              </b-col>
                              <b-col cols="12" sm="12" md="2" lg="2" xl="2">
                                <b-form-group>
                                  <b-button :disabled="!mainBody.violationData.idViolazioneCollegata"
                                            @click="editLinkedViolation()" style="border-radius: 50px" class="b-c-green"
                                  >
                                    <font-awesome-icon icon="pencil-alt" style="vertical-align: middle"/>
                                  </b-button>
                                </b-form-group>
                              </b-col>
                            </b-row>

                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                          <validation-provider :name="$tc('message.verbalNumber', 1).toLowerCase()"
                                               :rules="{ max: 25, required: tabs.violationData.index === currentTab }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.verbalNumber', 1)} (*)`"
                                          label-for="input-verbal-number">
                              <b-form-input id="input-verbal-number"
                                            v-model="mainBody.violationData.numeroVerbale"
                                            autocomplete="off" type="text"
                                            :placeholder="`${$tc('message.example', 1)}: 1`"
                                            :state="changed ? valid : null">
                              </b-form-input>

                              <div
                                  v-if="!valid && changed"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>

                        <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                          <b-form-group :label="`${$tc('message.verbalDate', 1)} (*)`"
                                        label-for="input-verbal-date">
                            <b-input-group>
                              <flat-pickr id="input-verbal-date"
                                          :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                          class="form-control"
                                          v-model="mainBody.violationData.dataVerbale"
                                          :config="verbalDateConfig"
                              >
                              </flat-pickr>
                              <div class="input-group-append">
                                <b-button @click="mainBody.violationData.dataVerbale = null"
                                          :disabled="!mainBody.violationData.dataVerbale">
                                  <font-awesome-icon icon="trash" class="mt-1"/>
                                </b-button>
                              </div>
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                          <validation-provider :name="$tc('message.issuedBy', 1).toLowerCase()"
                                               :rules="{ min: 2, max: 50, required: tabs.violationData.index === currentTab }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.issuedBy', 1)} (*)`"
                                          label-for="input-issued-by">
                              <b-form-input id="input-issued-by"
                                            v-model="mainBody.violationData.emessoDa"
                                            autocomplete="off" type="text"
                                            :placeholder="`${$tc('message.example', 1)}: Polizia di stato di Firenze`"
                                            :state="changed ? valid : null">
                              </b-form-input>

                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>

                        <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                          <validation-provider :name="$tc('message.numberPlate', 1).toLowerCase()"
                                               :rules="{ regex: /^[a-zA-Z0-9-]+$/, max: 15, required: tabs.violationData.index === currentTab }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.numberPlate', 1)} (*)`"
                                          label-for="input-number-plate">
                              <b-form-input id="input-number-plate"
                                            :disabled="items.length > 0 || (mainBody.violationData.verifica !== undefined && mainBody.violationData.verifica.stato !== 'DA_VERIFICARE') || mainBody.violationData.rimborso !== undefined || mainBody.violationData.pagamento !== undefined || mainBody.violationData.contestazione !== undefined"
                                            v-model="mainBody.violationData.targa"
                                            autocomplete="off" type="text"
                                            :placeholder="`${$tc('message.example', 1)}: GH4560PO`"
                                            :state="changed ? valid  : null">
                              </b-form-input>

                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>

                        <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                          <b-form-group :label="`${$tc('message.infringementDate', 1)} (*)`"
                                        label-for="input-infringement-date">
                            <b-input-group>
                              <flat-pickr id="input-infringement-date"
                                          :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                          class="form-control"
                                          v-model="mainBody.violationData.dataInfrazione"
                                          :config="infringementDateConfig"
                              >
                              </flat-pickr>
                              <div class="input-group-append">
                                <b-button @click="mainBody.violationData.dataInfrazione = null"
                                          :disabled="!mainBody.violationData.dataInfrazione">
                                  <font-awesome-icon icon="trash" class="mt-1"/>
                                </b-button>
                              </div>
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                          <b-form-group :label="`${$tc('message.infringementTime', 1)} (*)`"
                                        label-for="input-infringement-time">
                            <b-input-group>
                              <flat-pickr id="input-infringement-time"
                                          :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.timeFormat'))}`"
                                          class="form-control"
                                          v-model="mainBody.violationData.oraInfrazione"
                                          :config="timePicker"
                                          @on-change="disabledSave = false"
                              >
                              </flat-pickr>
                              <div class="input-group-append">
                                <b-button @click="mainBody.violationData.oraInfrazione = null"
                                          :disabled="!mainBody.violationData.oraInfrazione">
                                  <font-awesome-icon icon="trash" class="mt-1"/>
                                </b-button>
                              </div>
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                          <b-form-group :label="`${$tc('message.infringement', 1)} (*)`"
                                        label-for="input-infringement">
                            <model-list-select id="input-infringement"
                                               option-text="text"
                                               option-value="value"
                                               :placeholder="motivationOptions && motivationOptions.length
                                            !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                               v-model="mainBody.violationData.idMotivazioneInfrazione"
                                               :list="motivationOptions">
                            </model-list-select>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="12" md="6" lg="4" xl="6">
                          <validation-provider :name="$tc('message.locality', 1).toLowerCase()"
                                               :rules="{ max: 30, required: tabs.violationData.index === currentTab }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.locality', 1)} (*)`"
                                          label-for="input-locality">
                              <b-form-input id="input-locality"
                                            v-model="mainBody.violationData.localita"
                                            autocomplete="off" type="text"
                                            :placeholder="`${$tc('message.example', 1)}: Pontassieve (FI)`"
                                            :state="changed ? valid : null">
                              </b-form-input>

                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>

                        <b-col cols="12" sm="12" md="6" lg="4" xl="6">
                          <validation-provider :name="$tc('message.address', 1).toLowerCase()"
                                               :rules="{ max: 30, required: tabs.violationData.index === currentTab }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.address', 1)} (*)`"
                                          label-for="input-address">
                              <b-form-input id="input-address"
                                            v-model="mainBody.violationData.indirizzo"
                                            autocomplete="off" type="text"
                                            :placeholder="`${$tc('message.example', 1)}: via Garibaldi, 230`"
                                            :state="changed ? valid : null">
                              </b-form-input>

                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>

                        <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                          <validation-provider :name="$tc('message.penaltyChargeNoticeAmount', 1).toLowerCase()"
                                               :rules="{ min_value: 0, max: 10, required: tabs.violationData.index === currentTab }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.penaltyChargeNoticeAmount', 1)} (*)`"
                                          label-for="input-penalty-charge-notice-amount">
                              <b-input-group append="€">
                                <b-form-input id="input-penalty-charge-notice-amount"
                                              v-model="mainBody.violationData.importo"
                                              autocomplete="off" min="0" step="0.01"
                                              :placeholder="`${$tc('message.example', 1)}: 180.00`"
                                              @keypress="isNumber($event, mainBody.violationData.importo, false)"
                                              :state="changed ? valid : null">
                                </b-form-input>
                              </b-input-group>
                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>

                        <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                          <b-form-group :label="`${$tc('message.paymentDeadline', 1)} (*)`"
                                        label-for="input-payment-deadline">
                            <b-input-group>
                              <flat-pickr id="input-payment-deadline"
                                          :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                          class="form-control"
                                          v-model="mainBody.violationData.scadenza"
                                          :config="!violationID ? genericDateConfigExpirations : {}"
                              >
                              </flat-pickr>
                              <div class="input-group-append">
                                <b-button @click="mainBody.violationData.scadenza = null"
                                          :disabled="!mainBody.violationData.scadenza">
                                  <font-awesome-icon icon="trash" class="mt-1"/>
                                </b-button>
                              </div>
                              <b-button style="border-radius: 25px;" class=" ml-2"
                                        :class="checkDeadlinePaymentAlarm ? 'c-b-green' : 'c-b-grey'"
                                        @click="checkDeadlinePaymentAlarm = !checkDeadlinePaymentAlarm">
                                <font-awesome-icon style="vertical-align: middle" icon="bell"/>
                              </b-button>
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                          <validation-provider :name="$tc('message.drivingLicensePointsCharge', 1).toLowerCase()"
                                               :rules="{ min_value: 0, max: 10, required: tabs.violationData.index === currentTab }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.drivingLicensePointsCharge', 1)} (*)`"
                                          label-for="input-driving-licence-points-charge">
                              <b-form-input id="input-driving-licence-points-charge"
                                            v-model="mainBody.violationData.puntiPatente"
                                            autocomplete="off" type="number"
                                            :placeholder="`${$tc('message.example', 1)}: 3`"
                                            @keypress="isNumber($event, mainBody.violationData.puntiPatente, true)"
                                            :state="changed ? valid : null">
                              </b-form-input>

                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>

                        <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                          <validation-provider :name="$tc('message.reducedAmount', 1).toLowerCase()"
                                               :rules="{ min_value: 0, max: 15, required: tabs.violationData.index === currentTab }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.reducedAmount', 1)} (*)`"
                                          label-for="input-reduced-amount">
                              <b-input-group append="€">
                                <b-form-input id="input-reduced-amount"
                                              v-model="mainBody.violationData.importoRidotto"
                                              autocomplete="off" min="0" step="0.01"
                                              :placeholder="`${$tc('message.example', 1)}: 120.00`"
                                              @keypress="isNumber($event, mainBody.violationData.reducedAmount, false)"
                                              :state="changed > 0 ? valid : null">

                                </b-form-input>
                              </b-input-group>
                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>

                        <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                          <b-form-group :label="`${$tc('message.reducedPaymentDeadline', 1)} (*)`"
                                        label-for="input-reduced-payment-deadline">
                            <b-input-group>
                              <flat-pickr id="input-reduced-payment-deadline"
                                          :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                          class="form-control"
                                          v-model="mainBody.violationData.scadenzaRiduzione"
                                          :config="!violationID ? expirationDateConfig : {}"
                              >
                              </flat-pickr>
                              <div class="input-group-append">
                                <b-button @click="mainBody.violationData.scadenzaRiduzione = null"
                                          :disabled="!mainBody.violationData.scadenzaRiduzione">
                                  <font-awesome-icon icon="trash" class="mt-1"/>
                                </b-button>
                              </div>
                              <b-button style="border-radius: 25px;" class=" ml-2"
                                        :class="checkReducedPaymentDeadlineAlarm ? 'c-b-green' : 'c-b-grey'"
                                        @click="checkReducedPaymentDeadlineAlarm = !checkReducedPaymentDeadlineAlarm">
                                <font-awesome-icon style="vertical-align: middle" icon="bell"/>
                              </b-button>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row v-if="violationID !== null">
                        <b-col cols="12" sm="12" md="6" lg="4" xl="4">
                          <b-card>
                            <b-form-group :label="`${$tc('message.violationStatus', 1)}`"
                                          label-for="violation-status">
                              <div class="mt-2">
                                <font-awesome-icon v-b-popover.hover.top="'Stato verifica: accettata'" size="2x"
                                                   v-if="mainBody.violationData.statoVerifica === 'ACCETTATA'"
                                                   icon="check-circle" class="c-green mt-2 mb-1 mr-3"/>
                                <font-awesome-icon v-b-popover.hover.top="'Stato verifica: non accettata'" size="2x"
                                                   v-if="mainBody.violationData.statoVerifica === 'NON_ACCETTATA'"
                                                   icon="plus-circle" style="transform: rotate(45deg)"
                                                   class="c-green mt-2 mb-1 mr-3"/>
                                <font-awesome-icon v-b-popover.hover.top="'Stato verifica: da verificare'" size="2x"
                                                   v-if="mainBody.violationData.statoVerifica === 'DA_VERIFICARE'"
                                                   icon="question-circle" class="c-green mt-1 mb-1 mr-3"/>

                                <font-awesome-icon size="2x" v-b-popover.hover.top="mainBody.violationData.statoContestazione === 'ESEGUITO'
                                ? 'Stato contestazione: eseguita'
                                : 'Stato contestazione: non eseguita'"
                                                   :class="mainBody.violationData.statoContestazione === 'ESEGUITO' ? 'c-green' : 'c-grey'"
                                                   icon="balance-scale" class="c-grey mt-1 mb-1 mr-3"/>
                                <font-awesome-icon size="2x" v-b-popover.hover.top="mainBody.violationData.statoPagamento === 'ESEGUITO'
                                ? 'Stato pagamento: eseguito' : 'Stato pagamento: non eseguito'"
                                                   :class="mainBody.violationData.statoPagamento === 'ESEGUITO' ? 'c-green' : 'c-grey'"
                                                   icon="euro-sign" class="c-grey mt-1  mb-1 mr-3"/>
                                <inline-svg height="2rem" width="2.2rem" class="mb-0 mt-1"
                                            v-b-popover.hover.top="mainBody.violationData.statoRimborso ? 'Stato rimborso: richiesto' : 'Stato rimborso: non richiesto'"
                                            :class="mainBody.violationData.statoRimborso === 'ESEGUITO' ? 'c-green' : 'c-grey'"
                                            :src="mySVG"
                                            :fill="violationID !== null && mainBody.violationData.statoRimborso === 'RICHIESTO'
                                ? '#249a80' : 'darkgrey'"/>
                              </div>
                            </b-form-group>
                          </b-card>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-row>
              </transition>
            </b-container>
          </b-tab>
          <b-tab :title="`${$tc('message.attachment', 2)}`" :disabled="violationID === null">
            <b-container class="m-0 p-0 mw-100 mb-2">
              <transition :name="transitionName">
                <b-row v-show="tabs.attachment.index === currentTab && tabs.attachment.active">
                  <b-card class="mt-4 mb-4" :body-class="isMobile ? 'p-2' : ''">
                    <standard-table ref="attachmentTable"
                                    :items="items"
                                    :fields="fields"
                                    :search-place-holder="`${$tc('message.example', 1)}: AA999ZZ`"

                                    :row-before-search="{cols: 12,sm: 12,md: 12,lg: 2,xl: 2,order: 3,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                                    :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                                    :row-after-search="{cols: 12, sm: 12, md: 12, lg: 6, xl: 6, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                                    :after-search="{cols: 12, sm: 12, md: 12, lg: 12, xl: 12}"

                                    :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                                    :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                                    :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                                    :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"

                                    fullWidth="true"
                                    noContainerPadding="true"
                                    @rowDelete="deleteDocument($event.item)"
                                    @rowDownload="downloadDocument($event.item)"
                    >
                    </standard-table>
                  </b-card>
                  <b-row>
                    <b-col cols="12" sm="12" md="10" lg="10" xl="10">
                      <b-form-file id="input-new-attachment"
                                   accept=".pdf, .jpg, .jpeg, .png"
                                   v-model="mainBody.attachment.newDocument"
                                   :class="`lang-${$i18n.locale}`"
                                   :placeholder="`${$tc('message.select', 1)} ${$tc('message.new', 1).toLowerCase()} ${$tc('message.document', 1).toLowerCase()}`"
                      >
                      </b-form-file>
                    </b-col>
                    <b-col cols="12" sm="12" md="2" lg="2" xl="2">
                      <b-button :disabled="mainBody.attachment.newDocument === null" class="b-c-green"
                                @click="uploadDocument(mainBody.attachment.newDocument, currentViolation.idUuid + ';' + currentViolation.plateUuid + ';' + currentViolation.monthUuid)">
                        <font-awesome-icon icon="upload" style="vertical-align: middle"/>
                      </b-button>
                    </b-col>

                  </b-row>
                </b-row>
              </transition>
            </b-container>
          </b-tab>
          <b-tab :title="`${$tc('message.verification', 1)}`" :disabled="violationID === null">
            <b-container class="m-0 p-0 mw-100 mb-2">
              <transition :name="transitionName">
                <b-row style="justify-content: space-around"
                       v-show="tabs.verification.index === currentTab && tabs.verification.active">
                  <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                    <div class="mb-5">
                      <b-row class="mb-2">
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                          <b> {{ $tc('message.data', 1) + ' ' + $tc('message.infringement', 1).toLowerCase() }}</b>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                          {{ mainBody.verification.violationData.dataInfrazioneFormatted }}
                        </b-col>
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                          {{ mainBody.verification.violationData.targa }}
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                          {{ mainBody.verification.violationData.localita }}
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                          {{ mainBody.verification.violationData.indirizzo }}
                        </b-col>
                      </b-row>
                    </div>
                    <div v-if="!mainBody.verification.detectedPosition.verificaManuale" class="mb-5 pt-5">
                      <b-row class="mb-2">
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                          <b> {{ $tc('message.range', 1) }}</b>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" sm="12" md="3" lg="3" xl="3">
                          <b-input-group>
                            <flat-pickr id="input-time-from"
                                        :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.timeFormat'))}`"
                                        class="form-control"
                                        v-model="mainBody.verification.dataInizio"
                                        :disabled="mainBody.violationData.statoVerifica === 'ACCETTATA' || mainBody.violationData.statoVerifica === 'NON_ACCETTATA'"
                                        :config="timePicker"
                            >
                            </flat-pickr>
                          </b-input-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="3" lg="3" xl="3">
                          <b-input-group>
                            <flat-pickr id="input-time-to"
                                        :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.timeFormat'))}`"
                                        class="form-control"
                                        v-model="mainBody.verification.dataFine"
                                        :disabled="mainBody.violationData.statoVerifica === 'ACCETTATA' || mainBody.violationData.statoVerifica === 'NON_ACCETTATA'"
                                        :config="timePicker"
                            >
                            </flat-pickr>
                          </b-input-group>
                        </b-col>
                        <div v-if="warningRange" class="my-invalid-feedback ml-3 mt-2"><h6>Intervallo non valido</h6>
                        </div>
                      </b-row>
                    </div>
                    <div class="pt-5">
                      <b-row class="mb-2">
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                          <b> {{ $tc('message.position', 1) + ' ' + $tc('message.detected', 1).toLowerCase() }}</b>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col cols="12" sm="12" md="3" lg="3" xl="3">
                          <b-form-group :label="`${$tc('message.date', 1)}`"
                                        label-for="input-date">
                            <b-input-group>
                              <flat-pickr id="input-date"
                                          :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                          class="form-control"
                                          v-model="mainBody.verification.detectedPosition.date"
                                          :disabled="true"
                              >
                              </flat-pickr>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" sm="12" md="3" lg="3" xl="3">
                          <validation-provider :name="$tc('message.numberPlate', 1).toLowerCase()"
                                               :rules="{ regex: /^[a-zA-Z0-9-]+$/, max: 15 }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.numberPlate', 1)}`"
                                          label-for="input-number-plate">
                              <b-form-input id="input-number-plate"
                                            v-model="mainBody.verification.detectedPosition.targa"
                                            autocomplete="off" type="text"
                                            :disabled="true"
                                            :placeholder="`${$tc('message.example', 1)}: GH4560PO`"
                                            :state="changed ? valid : null">
                              </b-form-input>

                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                        <b-col cols="12" sm="12" md="3" lg="3" xl="3">
                          <validation-provider :name="$tc('message.brand', 1).toLowerCase()"
                                               :rules="{ regex: /^[a-zA-Z0-9-]+$/, max: 15 }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.brand', 1)}`"
                                          label-for="input-number-plate">
                              <b-form-input id="input-number-plate"
                                            v-model="mainBody.verification.detectedPosition.marca"
                                            autocomplete="off" type="text"
                                            :placeholder="`${$tc('message.example', 1)}: Fiat`"
                                            :disabled="mainBody.violationData.statoVerifica === 'ACCETTATA' || mainBody.violationData.statoVerifica === 'NON_ACCETTATA'"
                                            :state="changed ? valid : null">
                              </b-form-input>

                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                          <validation-provider :name="$tc('message.model', 1).toLowerCase()"
                                               :rules="{ max: 50 }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="$tc('message.model', 1)"
                                          label-for="input-template">
                              <b-form-input id="input-template"
                                            v-model="mainBody.verification.detectedPosition.modello"
                                            autocomplete="off" type="text"
                                            :placeholder="`${$tc('message.example', 1)}: Z150`"
                                            :disabled="mainBody.violationData.statoVerifica === 'ACCETTATA' || mainBody.violationData.statoVerifica === 'NON_ACCETTATA'"
                                            :state="changed ? valid : null">
                              </b-form-input>

                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" sm="12" md="3" lg="3" xl="3">
                          <b-form-group :label="`${$tc('message.engine', 1)}`"
                                        label-for="input-engine">
                            <b-form-input id="input-engine"
                                          v-model="mainBody.verification.detectedPosition.motore"
                                          autocomplete="off" type="text"
                                          :disabled="true"
                                          :placeholder="`${$tc('message.example', 1)}: On`"
                            >
                            </b-form-input>

                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="3" lg="3" xl="3">
                          <b-form-group :label="`${$tc('message.speed', 1)}`"
                                        label-for="input-speed">
                            <b-form-input id="input-speed"
                                          v-model="mainBody.verification.detectedPosition.velocita"
                                          autocomplete="off" type="number"
                                          :disabled="true"
                                          :placeholder="`${$tc('message.example', 1)}: 120`"
                                          @keypress="isNumber($event, mainBody.verification.detectedPosition.velocita, true)"
                            >

                            </b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="4" lg="4" xl="4">
                          <b-form-group :label="$t('message.driver')"
                                        label-for="input-driver-name">
                            <model-list-select id="input-driver-name"
                                               @input="disabledSave = false"
                                               option-text="text"
                                               :is-disabled="mainBody.violationData.statoVerifica === 'ACCETTATA' || mainBody.violationData.statoVerifica === 'NON_ACCETTATA'"
                                               option-value="value"
                                               :placeholder="driverOptions && driverOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                               v-model="mainBody.verification.detectedPosition.idAutista"
                                               :list="driverOptions">
                            </model-list-select>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row v-if="mainBody.verification.detectedPosition.verificaManuale || newVerification"
                             class="mt-5">
                        <b-col cols="12" sm="12" md="5" lg="5" xl="5">
                          <b-form-group
                              :label="`${$tc('message.verification', 1)} ${$tc('message.manual', 1).toLowerCase()}`"
                              :label-cols="8"
                              label-for="manual-verification">
                            <b-form-checkbox id="manual-verification"
                                             class="ml-2 mt-2"
                                             :disabled="!newVerification || disableManualVerification"
                                             v-model="mainBody.verification.detectedPosition.verificaManuale">
                            </b-form-checkbox>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="5" lg="5" xl="5"
                               v-if="mainBody.verification.detectedPosition.verificaManuale">
                          <validation-provider :name="$tc('message.responsible', 1).toLowerCase()"
                                               :rules="{ max: 50, required: currentTab === tabs.verification.index && mainBody.verification.detectedPosition.verificaManuale && newVerification}"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.responsible', 1)} (*)`"
                                          :label-cols="6"
                                          label-for="input-responsible">
                              <b-form-input id="input-responsible"
                                            :disabled="true"
                                            v-model="mainBody.verification.responsabile"
                                            autocomplete="off" type="text"
                                            :placeholder="`${$tc('message.example', 1)}: Carta di credito`"
                                            :state="changed ? valid : null">
                              </b-form-input>

                              <div v-if="changed && !valid"
                                   class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                      </b-row>
                    </div>

                  </b-col>
                  <div class="all-content">
                    <div v-if="newVerification && !mainBody.verification.detectedPosition.verificaManuale"
                         class="view-container"
                         :style="isMobile ? 'flex-flow: column wrap' : 'flex-flow: row wrap'">
                      <div class="map-container" :style="isMobile ? 'order: 3' : 'order: 2'">
                        <div class="my-map">
                          <Map :apiUrl="url"
                               :authToken="token"
                               ref="staticMap"
                               :vehicleId="vehicleSelected"
                               :driverId="driverSelected"
                               :tsStart="(filterStartMap / 1000) + ''"
                               :tsEnd="(filterEndMap / 1000) + ''"
                               usecase="history"
                               @click-position="clickPosition"
                               @loaded-positions="loadedHistoryPosition"
                               @alert-error="mapError"
                               v-on:put-verification="saveVerification($event)"
                               v-on:get-verification-screen="getVerificationScreen"
                               :screen-shot="true">
                          </Map>
                        </div>
                      </div>
                    </div>
                  </div>
                  <b-col v-if="!newVerification && image" cols="12" sm="12" md="12" lg="12" xl="6">
                    <img :src="image" width="100%" height="100%">
                  </b-col>

                </b-row>
              </transition>

            </b-container>
          </b-tab>
          <b-tab :title="`${$tc('message.payment', 1)}`" :disabled="violationID === null">
            <b-container class="m-0 p-0 mw-100 mb-2">
              <transition :name="transitionName">
                <b-row v-show="tabs.payment.index === currentTab && tabs.payment.active">
                  <b-col>
                    <b-container class="mw-100 mt-2">
                      <b-row class="mb-4">
                        <b-col>
                          <h4>
                            <b>
                              {{ $tc('message.paymentRegistration') }}
                            </b>
                          </h4>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                          <b-form-group :label="`${$tc('message.paymentDate', 1)} (*)`"
                                        :label-cols="6"
                                        label-for="input-linked-violation-id">
                            <b-input-group>
                              <flat-pickr id="input-payment-date"
                                          :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                          class="form-control"
                                          :disabled="violationID === null"
                                          v-model="mainBody.payment.data"
                                          :config="paymentDateConfig"
                              >
                              </flat-pickr>
                              <div class="input-group-append">
                                <b-button @click="mainBody.payment.data = null"
                                          :disabled="!mainBody.payment.data || violationID === null">
                                  <font-awesome-icon icon="trash" class="mt-1"/>
                                </b-button>
                              </div>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                          <validation-provider :name="$tc('message.paymentMethod', 1).toLowerCase()"
                                               :rules="{ max: 50, required: tabs.payment.index === currentTab }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.paymentMethod', 1)} (*)`"
                                          :label-cols="6"
                                          label-for="input-payment-method">
                              <b-form-input id="input-payment-method"
                                            :disabled="violationID === null"
                                            v-model="mainBody.payment.metodo"
                                            autocomplete="off" type="text"
                                            :placeholder="`${$tc('message.example', 1)}: Carta di credito`"
                                            :state="changed ? valid : null">
                              </b-form-input>

                              <div v-if="changed && !valid"
                                   class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                          <validation-provider :name="$tc('message.payedAmount', 1).toLowerCase()"
                                               :rules="{ min_value: 0, max: 15, required: tabs.payment.index === currentTab }"
                                               v-slot="{ changed, valid }">
                            <b-form-group :label="`${$tc('message.payedAmount', 1)} (*)`"
                                          :label-cols="6"
                                          label-for="input-payed-amount">
                              <b-input-group append="€">
                                <b-form-input id="input-payed-amount"
                                              :disabled="violationID === null"
                                              v-model="mainBody.payment.importo"
                                              autocomplete="off" min="0" step="0.01"
                                              :placeholder="`${$tc('message.example', 1)}: 1`"
                                              @keypress="isNumber($event, mainBody.payment.importo, false)"
                                              :state="changed ? valid : null">
                                </b-form-input>
                              </b-input-group>
                              <div v-if="changed && !valid"
                                   class="my-invalid-feedback"/>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                          <b-form-group :label="`${$tc('message.paymentReceipt', 1)}`"
                                        :label-cols="6"
                                        label-for="input-payment-receipt">
                            <b-row>
                              <b-col cols="12" sm="12" md="11" lg="11" xl="11" class="pr-0">
                                <b-form-file id="input-payment-receipt"
                                             :disabled="violationID === null"
                                             accept=".pdf, .jpg, .jpeg, .png"
                                             v-model="mainBody.payment.paymentReceipt"
                                             browse-text="paymentReceipt"
                                             :class="`lang-${$i18n.locale}`"
                                             :placeholder="`${$t('message.select')} ${$tc('message.attachment', 1).toLowerCase()}`"
                                />
                              </b-col>
                              <b-col cols="12" sm="12" md="1" lg="1" xl="1" class="pl-1">
                                <b-button
                                    :disabled="mainBody.payment.paymentReceipt === null || mainBody.payment.paymentReceipt === undefined"
                                    class="b-c-green ml-0"
                                    @click="uploadDocument(mainBody.payment.paymentReceipt, currentViolation.idUuid + ';' + currentViolation.plateUuid + ';' + currentViolation.monthUuid + ';' + paymentReceiptsCategoryUuid)">
                                  <font-awesome-icon icon="upload" style="vertical-align: middle"/>
                                </b-button>
                              </b-col>
                            </b-row>

                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row v-show="tabs.payment.index === currentTab && tabs.payment.active">
                        <b-card class="mt-4 mb-4" :body-class="isMobile ? 'p-2' : ''">
                          <b-row class="ml-1 mb-3">
                            <b>Ricevute salvate</b>
                          </b-row>
                          <standard-table ref="attachmentTable"
                                          :items="itemsReceipt"
                                          :fields="fields"
                                          :search-place-holder="`${$tc('message.example', 1)}: AA999ZZ`"

                                          :row-before-search="{cols: 12,sm: 12,md: 12,lg: 2,xl: 2,order: 3,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                                          :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                                          :row-after-search="{cols: 12, sm: 12, md: 12, lg: 6, xl: 6, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                                          :after-search="{cols: 12, sm: 12, md: 12, lg: 12, xl: 12}"

                                          :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                                          :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                                          :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                                          :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"

                                          fullWidth="true"
                                          noContainerPadding="true"
                                          @rowDelete="deleteDocument($event.item)"
                                          @rowDownload="downloadDocument($event.item)"
                          >
                          </standard-table>
                        </b-card>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-row>
              </transition>
            </b-container>
          </b-tab>
          <b-tab v-if="mainBody.employeeNotification" :title="`${$tc('message.employeeNotification', 1)}`" :disabled="violationID === null
          || mainBody.verification.stato === 'DA_VERIFICARE'">
            <b-container class="m-0 p-0 mw-100 mb-2">
              <transition :name="transitionName">
                <b-row v-show="tabs.employeeNotification.index === currentTab && tabs.employeeNotification.active">
                  <b-col>
                    <b-container class="mw-100 mt-2">
                      <b-row class="mb-2">
                        <b-col cols="6" sm="12" md="6" lg="6" xl="6">
                          <b-form-group :label="`${$tc('message.verbalNumber', 1)}`"
                                        :label-cols="4"
                                        label-for="verbal-number">
                            <h5 class="mt-2">
                              <b>
                                {{ mainBody.employeeNotification.numeroVerbale }}
                              </b>
                            </h5>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                          <b-row>
                            <b-form-group
                                class="mt-2 mr-3"
                                :label="`${$tc('message.conditions', 1)} ${$tc('message.notification', 3)}`"
                                label-for="notification-condition">
                            </b-form-group>
                            <font-awesome-icon v-if="mainBody.violationData.statoVerifica === 'ACCETTATA'"
                                               v-b-popover.hover.top="'Stato verifica: accettata'" size="2x"
                                               icon="check-circle" class="mr-3 mt-1 c-green"/>
                            <font-awesome-icon v-b-popover.hover.top="'Stato verifica: non accettata'" size="2x"
                                               v-if="mainBody.violationData.statoVerifica === 'NON_ACCETTATA'"
                                               icon="plus-circle" style="transform: rotate(45deg)"
                                               class="c-red mt-2 mb-1 mr-3"/>
                            <font-awesome-icon
                                :class="mainBody.violationData.statoPagamento === 'ESEGUITO' ? 'c-green' : 'c-red'"
                                v-b-popover.hover.top="mainBody.violationData.statoPagamento === 'ESEGUITO' ? 'Stato pagamento: eseguito' : 'Stato pagamento: non eseguito'"
                                size="2x" icon="euro-sign" class="mr-3 mt-1"/>
                          </b-row>
                        </b-col>
                        <b-col cols="12" sm="12" md="6" lg="3" xl="3">
                          <b-form-group :label="`${$tc('message.driver', 1)}`"
                                        label-for="driver">
                            <h5>
                              <b>
                                {{ mainBody.employeeNotification.autista }}
                              </b>
                            </h5>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="6" lg="3" xl="3">
                          <b-form-group :label="`${$tc('message.driverID', 1)}`"
                                        label-for="driver-id">
                            <h5>
                              <b>
                                {{ mainBody.employeeNotification.idAutista }}
                              </b>
                            </h5>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                          <b-row class="mt-4 mb-2">
                            <b-form-group
                                class="mt-2 mr-3 bold-text"
                                :label="`${$tc('message.debitAuthorization', 1)}`"
                                label-for="notification-condition">
                            </b-form-group>
                            <font-awesome-icon size="2x" icon="check-circle" class="mr-3 mt-1"
                                               :class="thisDriver && thisDriver.consensus ? 'c-green' : 'c-grey'"/>
                            <b-form-group
                                class="mt-2 mr-3 bold-text"
                                :label="`${$tc('message.subjectToWithholding', 1)}`"
                                label-for="notification-condition">
                            </b-form-group>
                            <font-awesome-icon size="2x" icon="plus-circle" style="transform: rotate(45deg)" class="mr-3 mt-1"
                                               :class="thisDriver && !thisDriver.exemption ? 'c-green' : 'c-red'"/>
                          </b-row>
                        </b-col>
                        <b-col cols="6" sm="12" md="6" lg="6" xl="6">
                          <b-form-group :label="`${$tc('message.modelOf', 1)} ${$tc('message.notification', 3)} (*)`"
                                        :label-cols="4"
                                        label-for="input-notification-model">
                            <model-list-select id="input-notification-model"
                                               @change="disabledSave = false"
                                               option-text="text"
                                               option-value="value"
                                               :is-disabled="isDefined(mainBody.employeeNotification.dataInvio)"
                                               :placeholder="notificationModelOptions && notificationModelOptions.length
                                             !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                               v-model="mainBody.employeeNotification.idTemplate"
                                               :list="notificationModelOptions">
                            </model-list-select>
                          </b-form-group>
                        </b-col>

                      </b-row>
                      <b-row>
                        <b-col cols="3" sm="12" md="4" lg="4" xl="3">
                          <b-form-group :label="`${$tc('message.installmentPayment', 1)}`"
                                        :label-cols="8"
                                        label-for="installment-payment">
                            <b-form-checkbox id="installment-payment"
                                             class="ml-2 mt-2"
                                             :disabled="isDefined(mainBody.employeeNotification.dataInvio)"
                                             v-model="mainBody.employeeNotification.pagamentoRateale">
                            </b-form-checkbox>
                          </b-form-group>
                        </b-col>
                        <b-col cols="4" sm="12" md="4" lg="4" xl="4">
                          <b-form-group :label="`${$tc('message.deductionOfDrivingLicensePoints', 1)}`"
                                        :label-cols="8"
                                        label-for="deduction-of-driving-license-points">
                            <b-form-checkbox id="deduction-of-driving-license-points"
                                             class=" mt-2"
                                             :disabled="isDefined(mainBody.employeeNotification.dataInvio)"
                                             v-model="mainBody.employeeNotification.puntiPatente">
                            </b-form-checkbox>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="4" sm="12" md="4" lg="3" xl="3">
                          <b-form-group :label="`${$tc('message.chargeable', 1)}`"
                                        :label-cols="6"
                                        label-for="deduction-of-driving-license-points">
                            <switch-button v-model="mainBody.employeeNotification.addebitabile"
                                           :color="{checked: '#249a80', unchecked: '#dc3545'}"
                                           id="active-notification"
                                           :disabled="isDefined(mainBody.employeeNotification.dataInvio)"
                                           :sync="true"
                                           :width="90"
                                           :height="32"
                                           :font-size="15.5"
                                           :speed="500"
                                           :labels="true">
                              <template slot="checked">
                                {{ $t('message.yes') }}
                              </template>
                              <template slot="unchecked">
                                {{ $t('message.no') }}
                              </template>
                            </switch-button>
                          </b-form-group>
                        </b-col>
                        <b-col v-if="!mainBody.employeeNotification.addebitabile" cols="4" sm="12" md="4" lg="4" xl="4">
                          <validation-provider :name="$tc('message.authorized', 1).toLowerCase()"
                                               :rules="{ max: 30, required: currentTab === tabs.employeeNotification.index && !mainBody.employeeNotification.addebitabile }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.authorized', 1)} (*)`"
                                          :label-cols="6"
                                          label-for="input-other-mail-address">
                              <b-form-input id="input-other-mail-address"
                                            v-model="mainBody.employeeNotification.autorizzato"
                                            autocomplete="off" type="text"
                                            :disabled="isDefined(mainBody.employeeNotification.dataInvio)"
                                            :placeholder="`${$tc('message.example', 1)}: Mario Bianchi`"
                                            :state="changed ? valid : null">
                              </b-form-input>

                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="6" sm="12" md="6" lg="6" xl="6" class="mt-4">
                          <b-form-group :label="`${$tc('message.notificationMailAddress', 1)}`"
                                        :label-cols="4"
                                        label-for="notification-mail-address">
                            <h5 class="mt-2">
                              <b>
                                {{ mainBody.employeeNotification.email }}
                              </b>
                            </h5>
                          </b-form-group>
                        </b-col>
                        <b-col cols="5" sm="12" md="5" lg="5" xl="5">
                          <validation-provider :name="$tc('message.otherMailAddress', 1).toLowerCase()"
                                               :rules="{ max: 60, email: true }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.otherMailAddress', 1)}`"
                                          label-for="input-mail-address">
                              <b-form-input id="input-mail-address"
                                            v-model="mainBody.employeeNotification.emailSecondaria"
                                            autocomplete="off" type="text"
                                            :disabled="isDefined(mainBody.employeeNotification.dataInvio)"
                                            :placeholder="`${$tc('message.example', 1)}: prova@gmail.com`"
                                            :state="changed ? valid : null">
                              </b-form-input>

                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                        <b-col cols="6" sm="12" md="6" lg="6" xl="6" class="mt-4">
                          <validation-provider :name="$tc('message.ccAdministration', 1).toLowerCase()"
                                               :rules="{ max: 60, email: true }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.ccAdministration', 1)}`"
                                          :label-cols="4"
                                          label-for="input-cc-administration">
                              <b-form-input id="input-cc-administration"
                                            v-model="mainBody.employeeNotification.emailAmministrazione"
                                            autocomplete="off" type="text"
                                            :disabled="isDefined(mainBody.employeeNotification.dataInvio)"
                                            :placeholder="`${$tc('message.example', 1)}: amministrazione@gmail.com`"
                                            :state="changed > 0 ? valid : null">
                              </b-form-input>

                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                          <b-button class="b-c-green" @click="sendEmployeeNotification()"
                                    id="send-notification-button"
                                    v-b-tooltip.hover :title="mainBody.verification.stato === 'NON_ACCETTATA'
                                    || mainBody.violationData.statoPagamento === 'NON_ESEGUITO'
                                    || !isDefined(mainBody.violationData.rimborso)
                                    || !isDefined(mainBody.violationData.rimborso.idTemplate)  ? 'Inserisci i campi obbligatori e clicca \'Salva\'' : ''"
                                    v-if="!isDefined(mainBody.employeeNotification.dataInvio)"
                                    :disabled="mainBody.verification.stato === 'NON_ACCETTATA'
                                    || mainBody.violationData.statoPagamento === 'NON_ESEGUITO'
                                    || !isDefined(mainBody.violationData.rimborso)
                                    || !isDefined(mainBody.violationData.rimborso.idTemplate)">
                            {{ `${$tc('message.send', 1)} ${$tc('message.notification', 3)}` }}
                          </b-button>
                        </b-col>
                        <b-col v-if="isDefined(mainBody.employeeNotification.dataInvio)" cols="12" sm="12" md="6" lg="6"
                               xl="6">
                          <b-form-group
                              :label-cols="3"
                              :label="`${$tc('message.notificationSendDate', 1)}`"
                              label-for="notification-send-date">
                            <b-row class="mt-2">
                              <div class=" bold-text">
                                {{ mainBody.employeeNotification.dataInvio }}
                              </div>
                              <font-awesome-icon size="2x" icon="check-circle" class="c-green ml-3"/>
                            </b-row>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>

                </b-row>
              </transition>
            </b-container>
          </b-tab>
          <b-tab :title="`${$tc('message.dispute', 1)}`" :disabled="violationID === null
          || mainBody.verification.stato === 'DA_VERIFICARE'">
            <b-container class="m-0 p-0 mw-100 mb-2">
              <transition :name="transitionName">
                <b-row v-show="tabs.dispute.index === currentTab && tabs.dispute.active">
                  <b-col>
                    <b-container class="mw-100 mt-2">
                      <b-row>
                        <b-col cols="6" sm="12" md="6" lg="6" xl="6">
                          <b-form-group :label="`${$tc('message.verbalNumber', 1)}`"
                                        :label-cols="4"
                                        label-for="verbal-number-dispute">
                            <h5 class="mt-2">
                              <b>
                                {{ mainBody.dispute.numeroVerbale }}
                              </b>
                            </h5>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                          <b-row>
                            <b-form-group
                                class="mt-2 mr-3"
                                :label="`${$tc('message.conditions', 1)} ${$tc('message.dispute', 2)}`"
                                label-for="notification-condition">
                            </b-form-group>
                            <font-awesome-icon v-b-popover.hover.top="'Stato verifica: accettata'" size="2x"
                                               v-if="mainBody.violationData.statoVerifica === 'ACCETTATA'"
                                               icon="check-circle" class="c-red mt-2 mb-1 mr-3"/>
                            <font-awesome-icon v-b-popover.hover.top="'Stato verifica: non accettata'" size="2x"
                                               v-if="mainBody.violationData.statoVerifica === 'NON_ACCETTATA'"
                                               icon="plus-circle" style="transform: rotate(45deg)"
                                               class="c-green mt-2 mb-1 mr-3"/>
                          </b-row>
                        </b-col>
                        <b-col cols="6" sm="12" md="6" lg="6" xl="6">
                          <b-form-group :label="`${$tc('message.modelOf', 1)} ${$tc('message.dispute', 3)} (*)`"
                                        :label-cols="4"
                                        label-for="input-dispute-model">
                            <model-list-select id="input-dispute-model"
                                               option-text="text"
                                               option-value="value"
                                               :is-disabled="isDefined(mainBody.dispute.dataInvio)"
                                               :placeholder="disputeModelOptions && disputeModelOptions.length
                                             !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                               v-model="mainBody.dispute.idTemplate"
                                               :list="disputeModelOptions">
                            </model-list-select>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                          <validation-provider :name="$tc('message.motivation', 2)"
                                               :rules="{ max: 250, required: tabs.dispute.index === currentTab }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.motivation', 2)} (*)`"
                                          :label-cols="2"
                                          label-for="input-motivation">
                              <b-form-textarea id="input-motivation"
                                               rows="3"
                                               :disabled="isDefined(mainBody.dispute.dataInvio)"
                                               v-model="mainBody.dispute.motivazione"
                                               autocomplete="off" type="text"
                                               placeholder="Inserimento testo della contestazione"
                                               :state="changed ? valid : null">
                              </b-form-textarea>

                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="6" sm="12" md="6" lg="6" xl="6">
                          <validation-provider
                              :name="$tc('message.mailAddressOfTheFileManagementClerk', 1).toLowerCase()"
                              :rules="{ max: 60, email: true, required: tabs.dispute.index === currentTab }"
                              v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.mailAddressOfTheFileManagementClerk', 1)} (*)`"
                                          :label-cols="4" class="mt-5"
                                          label-for="input-dispute-mail-address">
                              <b-form-input id="input-dispute-mail-address"
                                            v-model="mainBody.dispute.email"
                                            :disabled="isDefined(mainBody.dispute.dataInvio)"
                                            autocomplete="off" type="text"
                                            :placeholder="`${$tc('message.example', 1)}: prova@gmail.com`"
                                            :state="changed ? valid : null">
                              </b-form-input>

                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                        <b-col cols="6" sm="12" md="6" lg="6" xl="6">
                          <validation-provider :name="$tc('message.otherMailAddress', 1).toLowerCase()"
                                               :rules="{ max: 60, email: true }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.otherMailAddress', 1)}`"
                                          class="mt-3"
                                          label-for="input-other-mail-address">
                              <b-form-input id="input-other-mail-address"
                                            v-model="mainBody.dispute.emailSecondaria"
                                            :disabled="isDefined(mainBody.dispute.dataInvio)"
                                            autocomplete="off" type="text"
                                            :placeholder="`${$tc('message.example', 1)}: prova@gmail.com`"
                                            :state="changed ? valid : null">
                              </b-form-input>

                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                        <b-col cols="6" sm="12" md="6" lg="6" xl="6">
                          <validation-provider :name="$tc('message.ccAdministration', 1).toLowerCase()"
                                               :rules="{ max: 60, email: true }"
                                               v-slot="{ changed, valid, errors }">
                            <b-form-group :label="`${$tc('message.ccAdministration', 1)}`"
                                          :label-cols="4"
                                          label-for="input-cc-administration">
                              <b-form-input id="input-cc-administration"
                                            v-model="mainBody.dispute.emailAmministrazione"
                                            :disabled="isDefined(mainBody.dispute.dataInvio)"
                                            autocomplete="off" type="text"
                                            :placeholder="`${$tc('message.example', 1)}: amministrazione@gmail.com`"
                                            :state="changed ? valid : null">
                              </b-form-input>

                              <div
                                  v-if="changed && !valid"
                                  class="my-invalid-feedback"><h6>{{ first(errors) }}</h6></div>
                            </b-form-group>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">

                        </b-col>
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                          <b-form-group :label="`${$tc('message.deadlines', 1)}`"
                                        :label-cols="4"
                                        label-for="input-deadlines">
                            <b-input-group>
                              <flat-pickr id="input-deadlines"
                                          :placeholder="`${$tc('message.example', 1)}: ${DateTime.local().toFormat($t('message.dateFormat'))}`"
                                          class="form-control"
                                          :disabled="isDefined(mainBody.dispute.dataInvio)"
                                          v-model="mainBody.dispute.dataScadenza"
                                          :config="genericDateConfigExpirations"
                              >
                              </flat-pickr>
                              <div class="input-group-append">
                                <b-button @click="mainBody.dispute.dataScadenza = null"
                                          :disabled="!mainBody.dispute.dataScadenza">
                                  <font-awesome-icon icon="trash" class="mt-1"/>
                                </b-button>
                              </div>
                              <b-button style="border-radius: 50px;" class=" ml-2"
                                        :class="checkTermsDeadlineDeadlineAlarm ? 'c-b-green' : 'c-b-grey'"
                                        @click="checkTermsDeadlineDeadlineAlarm = !checkTermsDeadlineDeadlineAlarm">
                                <font-awesome-icon style="vertical-align: middle" icon="bell"/>
                              </b-button>

                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12" sm="12" md="6" lg="6" xl="6" class=" pt-2 pb-1">
                          <b-button @click="sendDisputeNotification"
                                    id="send-dispute-button"
                                    v-b-tooltip.hover :title="mainBody.verification.stato === 'ACCETTATA' || mainBody.violationData.contestazione === undefined
                                    ? 'Inserisci i campi obbligatori e clicca \'Salva\'' : ''"
                                    v-if="!isDefined(mainBody.dispute.dataInvio)"
                                    :disabled="mainBody.verification.stato === 'ACCETTATA' || mainBody.violationData.contestazione === undefined"
                                    class="b-c-green">
                            {{ `${$tc('message.send', 1)} ${$tc('message.dispute', 2)}` }}
                          </b-button>
                        </b-col>
                        <b-col v-if="isDefined(mainBody.dispute.dataInvio)" cols="12" sm="12" md="6" lg="6" xl="6">
                          <b-form-group :label="`${$tc('message.forward', 1)} ${$tc('message.dispute', 2)}`"
                                        :label-cols="4"
                                        label-for="forward">
                            <b-input-group>
                              <h5 class="mt-2">
                                <b>
                                  {{ mainBody.dispute.dataInvio }}
                                </b>
                              </h5>
                              <font-awesome-icon class="c-green ml-3" style="vertical-align: middle" size="2x"
                                                 icon="check-circle">

                              </font-awesome-icon>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-col>
                </b-row>
              </transition>
            </b-container>
          </b-tab>
        </b-tabs>
        <b-container class="mw-100 mb-3 ml-2">
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="2" xl="2"
                   v-if="currentTab === tabs.verification.index && !newVerification">
              <h6>{{ $t('message.verificationStatus') }}</h6>
              <b-card id="verification-status-read">
                <b-row style="justify-content: center">
                  <font-awesome-icon v-if="mainBody.verification.stato === 'NON_ACCETTATA'"
                                     size="2x"
                                     id="not-accepted-status-read"
                                     v-b-popover.hover.top="'Stato verifica: non accettata'"
                                     style="transform: rotate(45deg)"
                                     icon="plus-circle"
                                     class="c-green"/>
                  <font-awesome-icon v-if="mainBody.verification.stato === 'ACCETTATA'"
                                     v-b-popover.hover.top="'Stato verifica: accettata'"
                                     size="2x"
                                     id="accepted-status-read"
                                     icon="check-circle"
                                     class='c-green'/>
                </b-row>
              </b-card>
            </b-col>
            <b-col class=" justify-content-end d-flex" :class="currentTab === tabs.verification.index ? 'mt-5' : 'mt-3'"
                   style="height: 2.5rem">
              <b-button style="border-radius: 25px" class="fas fa-trash mr-4 b-c-green"
                        id="delete-penalty-charge-notice"
                        @click="$refs.serviceDelete.show()"
                        v-if="currentTab !== tabs.attachment.index && currentTab !== tabs.verification.index"
                        :disabled="violationID === null ||
                        mainBody.violationData.statoPagamento === 'EFFETTUATO' ||
                        mainBody.violationData.statoContestazione === 'ESEGUITA' ||
                        mainBody.violationData.statoRimborso === 'RICHIESTO'"
              >
              </b-button>
              <!-- config[crud], create - read - update - delete -->
              <b-button class="b-c-green mr-2" @click="savePenaltyChargeNotice(false)"
                        v-if="currentTab === tabs.verification.index && newVerification"
                        id="save-verification" :disabled="disabledSave || invalid">
                {{ $t('message.save') + ' ' + $t('message.verification').toLowerCase() }}
              </b-button>

              <b-button class="b-c-green mr-2" @click="reopenVerification()"
                        v-if="(currentTab === tabs.verification.index && !newVerification)"
                        id="reopen-verification">
                {{ $t('message.reopen') + ' ' + $t('message.verification').toLowerCase() }}
              </b-button>

              <!-- config[crud], create - read - update - delete -->
              <b-button class="b-c-green mr-2" @click="savePenaltyChargeNotice(false)"
                        v-if="(currentTab === tabs.employeeNotification.index
                        && !isDefined(mainBody.employeeNotification.dataInvio))
                        || (currentTab === tabs.dispute.index
                        && !isDefined(mainBody.dispute.dataInvio))
                        || currentTab === tabs.violationData.index
                        || currentTab === tabs.payment.index"
                        id="save-penalty-charge-notice" :disabled="disabledSave || invalid">{{ $t('message.save') }}
              </b-button>

              <!-- config[crud], create - read - update - delete -->
              <b-button class="b-c-green mr-2" @click="savePenaltyChargeNotice(true)"
                        v-if="(currentTab === tabs.employeeNotification.index
                        && !isDefined(mainBody.employeeNotification.dataInvio))
                        || (currentTab === tabs.dispute.index
                        && !isDefined(mainBody.dispute.dataInvio))
                        || currentTab === tabs.violationData.index
                        || currentTab === tabs.payment.index"
                        id="save-and-close-penalty-charge-notice" :disabled="invalid || disabledSave">
                {{ $t('message.saveClose') }}
              </b-button>

              <b-button class="b-c-green" id="close-penalty-charge-notice" @click="pushBack()">
                {{ $t('message.close') }}
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </validation-observer>
    </b-card>

    <popup ref="popup" :position="position" v-on:redirect="redirect" v-show="position" :lang="lang" :$t="$tc"
           hideLabel="true"/>

    <b-modal ref="saveCheckModal" id="saveCheckModal" :title="`${$t('message.caution')}!`"
             no-close-on-backdrop no-close-on-esc hide-header-close>
      <b-container>
        <h5>{{ $t('warnings.notSavedTabChanges') }}</h5>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button id="nw-save-check-continue" class="m-1 b-c-green" @click="hideSaveCheckModal(true)">
          {{ $t('message.continue') }}
        </b-button>

        <b-button id="nw-save-check-close" class="m-1 b-c-green" @click="hideSaveCheckModal(false)">
          {{ $t('message.close') }}
        </b-button>
      </div>
    </b-modal>

    <b-modal ref="resetSavedPosition" id="resetSavedPosition" :title="`${$t('message.caution')}!`"
             no-close-on-backdrop no-close-on-esc hide-header-close>
      <b-container>
        <h5>{{ $t('warnings.resetSavedPosition') }}</h5>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button id="reset-saved-position-continue" class="m-1 b-c-green"
                  @click="$refs.resetSavedPosition.hide(); resetSavedPosition = true; putVerification(mainBody.verification.detectedPosition)">
          {{ $t('message.continue') }}
        </b-button>

        <b-button id="reset-saved-position-close" class="m-1 b-c-green" @click="$refs.resetSavedPosition.hide()">
          {{ $t('message.close') }}
        </b-button>
      </div>
    </b-modal>

    <b-modal ref="chooseState" id="chooseState" :title="`${$t('message.caution')}!`"
             no-close-on-backdrop no-close-on-esc hide-header-close>
      <b-container>
        <b-col>
          <h5>{{ $t('warnings.chooseStatus') }}</h5>
          <b-card id="verification-status">
            <b-row style="justify-content: space-around">
              <font-awesome-icon @click="mainBody.verification.stato = 'NON_ACCETTATA'"
                                 size="2x"
                                 id="not-accepted-status"
                                 v-b-popover.hover.top="'Stato verifica: non accettata'"
                                 style="transform: rotate(45deg)"
                                 icon="plus-circle"
                                 :class="mainBody.verification.stato === 'NON_ACCETTATA' ? 'c-green' : 'c-grey'"/>
              <font-awesome-icon @click="mainBody.verification.stato = 'ACCETTATA'"
                                 v-b-popover.hover.top="'Stato verifica: accettata'"
                                 size="2x"
                                 id="accepted-status"
                                 icon="check-circle"
                                 :class="mainBody.verification.stato === 'ACCETTATA'? 'c-green' : 'c-grey'"/>
            </b-row>
          </b-card>
        </b-col>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button :disabled="!mainBody.verification.stato" id="choose-state-continue" class="m-1 b-c-green" @click="mainBody.verification.detectedPosition.stato === 'DA_VERIFICARE'
        ? putVerification(mainBody.verification.detectedPosition)
        : ( $refs.chooseState.hide(), $refs.resetSavedPosition.show())">{{ $t('message.continue') }}
        </b-button>

        <b-button id="choose-state-close" class="m-1 b-c-green" @click="$refs.chooseState.hide()">
          {{ $t('message.close') }}
        </b-button>
      </div>
    </b-modal>

    <b-modal ref="notAuthorizedModal" id="notAuthorizedModal" :title="`${$t('message.caution')}!`"
             no-close-on-backdrop no-close-on-esc hide-header-close>
      <b-container>
        <h5>{{ $t('warnings.notSavedTabChanges') }}</h5>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button id="nw-not-authorized-close" class="m-1 b-c-green" @click="$refs.notAuthorizedModal.hide()">
          {{ $t('message.close') }}
        </b-button>
      </div>
    </b-modal>

    <b-modal ref="warningDisputeNotSavable" id="warningDisputeNotSavable" :title="`${$t('message.caution')}!`"
             no-close-on-backdrop no-close-on-esc hide-header-close>
      <b-container>
        <h5>{{ $t('warnings.disputeNotSavable') }}</h5>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button id="nw-not-authorized-close" class="m-1 b-c-green" @click="$refs.warningDisputeNotSavable.hide()">
          {{ $t('message.close') }}
        </b-button>
      </div>
    </b-modal>

    <b-modal ref="warningVerificationNotReopenable" id="warningDisputeNotSavable" :title="`${$t('message.caution')}!`"
             no-close-on-backdrop no-close-on-esc hide-header-close>
      <b-container>
        <h5>{{ $t('warnings.verificationNotReopenable') }} {{
            isDefined(mainBody.dispute.dataInvio) ? $t('warnings.disputeSent') : $t('warnings.employeeNotificationSent')
          }}</h5>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button id="nw-not-authorized-close" class="m-1 b-c-green"
                  @click="$refs.warningVerificationNotReopenable.hide()">
          {{ $t('message.close') }}
        </b-button>
      </div>
    </b-modal>

    <b-modal ref="warningNotificationNotSavable" id="warningDisputeNotSavable" :title="`${$t('message.caution')}!`"
             no-close-on-backdrop no-close-on-esc hide-header-close>
      <b-container>
        <h5>{{ $t('warnings.notificationNotSavable') }}</h5>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button id="nw-not-authorized-close" class="m-1 b-c-green"
                  @click="$refs.warningNotificationNotSavable.hide(); pushBack()">
          {{ $t('message.close') }}
        </b-button>
      </div>
    </b-modal>

    <b-modal ref="serviceDelete" id="serviceDelete" :title="`${$t('message.caution')}!`">
      <b-container>
        <h5>{{ $t('message.deleteCheck') }}?</h5>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <!-- config[crud], create - read - update - delete -->
        <b-button id="nw-delete-continue" class="m-1 b-c-green"
                  v-if="config.d" @click="deletePenaltyChargeNotice()">{{ $t('message.saveClose') }}
        </b-button>

        <b-button id="nw-delete-close" class="m-1 b-c-green" @click="$refs.serviceDelete.hide()">
          {{ $t('message.close') }}
        </b-button>
      </div>
    </b-modal>

  </b-container>
</template>

<script>
import Vue from 'vue'
import { DateTime } from 'luxon'
import { Italian } from 'flatpickr/dist/l10n/it'
import { cloneDeep, find, first, isNil, keys, orderBy } from 'lodash'
import axiosRetry from 'axios-retry'

const axios = require('axios')

export default {
  name: 'EditPenaltyChargeNotice',
  data () {
    const violationID = this.$route.params.id !== 'new' ? this.$route.params.id : null
    const config = this.$route.meta.config
    const token = Vue.getLocalStorage('session').token
    const defaultStart = DateTime.local().set({
      minute: 0,
      second: 0,
      millisecond: 0
    })
    const BASE_URL = Vue.getBaseUrl()
    const BASE_URL_PENALTY_CHARGE_NOTICE = Vue.getBaseUrlPenaltyChargeNotice()
    const BASE_URL_AWDOC = Vue.getBaseUrlAWDoc()
    const timePicker = {
      wrap: true,
      enableTime: true,
      enableSeconds: true,
      noCalendar: true,
      locale: Italian
    }
    const genericDateConfig = {
      dateFormat: 'Y-m-d',
      mode: 'single',
      altFormat: 'D j M Y',
      altInput: true,
      locale: Italian,
      minDate: '',
      maxDate: DateTime.local().set({
        day: DateTime.local().day + 1
      }).toISODate(),
      disable: [DateTime.local().set({
        day: DateTime.local().day + 1
      }).toISODate()]
    }
    const genericDateConfigExpirations = {
      dateFormat: 'Y-m-d',
      mode: 'single',
      altFormat: 'D j M Y',
      altInput: true,
      locale: Italian,
      minDate: DateTime.local().toISODate(),
      maxDate: '',
      disable: []
    }
    const lang = Vue.getLocalStorage('lang')
    const headers = {
      domain: Vue.getDomain(),
      organization: Vue.getOrganization()
    }

    return {
      DateTime,
      timePicker,
      genericDateConfigExpirations,
      config,
      first,
      violationID,
      token,
      BASE_URL_PENALTY_CHARGE_NOTICE,
      BASE_URL_AWDOC,
      headers,
      lang,
      currentTab: 0,
      transitionName: 'slide-left',
      tabs: {
        violationData: {
          index: 0,
          active: true,
          name: 'violationData'
        },
        attachment: {
          index: 1,
          active: false,
          name: 'attachment'
        },
        verification: {
          index: 2,
          active: false,
          name: 'verification'
        },
        payment: {
          index: 3,
          active: false,
          name: 'payment'
        },
        employeeNotification: {
          index: 4,
          active: false,
          name: 'employeeNotification'
        },
        dispute: {
          index: 5,
          active: false,
          name: 'dispute'
        }
      },
      mainBody: {
        violationData: {
          id: violationID,
          numeroVerbale: null,
          dataInfrazione: null,
          oraInfrazione: null,
          targa: null,
          importo: null,
          scadenza: null,
          importoRidotto: null,
          scadenzaRiduzione: null,
          idViolazioneCollegata: null,
          idMotivazioneInfrazione: null,
          dataVerbale: null,
          emessoDa: null,
          localita: null,
          indirizzo: null,
          puntiPatente: null
        },
        payment: {
          data: null,
          metodo: null,
          importo: null,
          stato: null
        },
        employeeNotification: {
          numeroVerbale: null,
          notificationCondition: null,
          autista: null,
          idAutista: null,
          subjectToWithholding: null,
          debitAuthorization: null,
          idTemplate: null,
          pagamentoRateale: null,
          puntiPatente: null,
          email: null,
          emailSecondaria: null,
          emailAmministrazione: null,
          dataInvio: null,
          addebitabile: null,
          autorizzato: null
        },
        dispute: {
          numeroVerbale: null,
          disputeConditions: null,
          idTemplate: null,
          motivazione: null,
          email: null,
          emailSecondaria: null,
          emailAmministrazione: null,
          dataScadenza: null,
          dataInvio: null
        },
        attachment: {
          newDocument: null
        },
        verification: {
          violationData: {
            dataInfrazione: null,
            oraInfrazione: null,
            targa: null,
            localita: null,
            indirizzo: null
          },
          detectedPosition: {
            targa: null,
            date: null,
            marca: null,
            modello: null,
            motore: null,
            velocita: null,
            idAutista: null,
            nomeAutista: null,
            email: null
          },
          stato: null,
          dataInizio: null,
          dataFine: null
        }
      },
      violationOptions: [],
      notificationModelOptions: [],
      disputeModelOptions: [],
      violations: [],
      itemChanged: false,
      infringementDateConfig: cloneDeep(genericDateConfig),
      paymentDateConfig: cloneDeep(genericDateConfig),
      verificationDateConfig: cloneDeep(genericDateConfig),
      expirationDateConfig: cloneDeep(genericDateConfigExpirations),
      verbalDateConfig: cloneDeep(genericDateConfig),
      max: 10000000,
      min: 0,
      disabledSave: true,
      mySVG: require('../../assets/euro.svg'),
      items: [],
      fields: [
        {
          key: 'download',
          label: ''
        },
        {
          key: 'delete',
          label: ''
        },
        {
          key: 'title',
          label: this.$tc('message.document', 2) + ' ' + this.$tc('message.attachment', 2).toLowerCase(),
          sortable: true
        },
        {
          key: 'valid_from',
          label: this.$tc('message.date', 1) + ' ' + this.$tc('message.inserting', 2).toLowerCase(),
          sortable: true
        },
        {
          key: 'document_type',
          label: this.$tc('message.type', 1) + ' ' + this.$tc('message.document', 2).toLowerCase(),
          sortable: true
        }
      ],
      isMobile: false,
      checkCircleVerification: false,
      xCircleVerification: false,
      checkCircleEmployeeNotification: false,
      euroSignEmployeeNotification: false,
      checkDebitAuthorization: false,
      checkSubjectToWithholding: false,
      checkDisputeCondition: false,
      checkDeadlinePaymentAlarm: false,
      checkReducedPaymentDeadlineAlarm: false,
      checkTermsDeadlineDeadlineAlarm: false,
      oldTabIndex: 0,
      newTabIndex: 0,
      saveCheckModalIsActive: false,
      violationDataWatcher: null,
      attachmentWatcher: null,
      verificationWatcher: null,
      paymentWatcher: null,
      employeeNotificationWatcher: null,
      disputeWatcher: null,
      map: null,
      url: BASE_URL,
      vehicleSelected: '',
      driverSelected: '',
      filterStart: defaultStart.plus({ hours: -3 }).toMillis(),
      filterEnd: defaultStart.toMillis(),
      filterStartMap: defaultStart.plus({ hours: -3 }).toMillis(),
      filterEndMap: defaultStart.toMillis(),
      loadedItemsTimeout: null,
      position: null,
      window: {
        width: 0,
        height: 0
      },
      allVehiclesWithObu: [],
      allDrivers: [],
      allTrackers: [],
      originalDrivers: [],
      originalVehicles: [],
      myDate: null,
      delayedStart: null,
      delayedEnd: null,
      hourRangeSelector: null,
      img: null,
      initialInfringementTime: null,
      resetSavedPosition: false,
      newVerification: true,
      positionImage: null,
      close: false,
      image: null,
      warningRange: false,
      thisDriver: {},
      driverOptions: [],
      drivers: [],
      switchToLinkedViolation: false,
      originalLinkedViolationId: null,
      motivationOptions: [],
      violationCategoryUuid: null,
      idCategoryUuid: null,
      plateCategoryUuid: null,
      dateCategoryUuid: null,
      paymentReceiptsCategoryUuid: null,
      directoryNamesDates: [
        '01_Gennaio',
        '02_Febbraio',
        '03_Marzo',
        '04_Aprile',
        '05_Maggio',
        '06_Giugno',
        '07_Luglio',
        '08_Agosto',
        '09_Settembre',
        '10_Ottobre',
        '11_Novembre',
        '12_Dicembre'
      ],
      currentViolation: {
        idUuid: '',
        plateUuid: '',
        monthUuid: ''
      },
      itemsReceipt: [],
      awdocAuthenticated: true,
      disableManualVerification: false,
      companyOptions: []
    }
  },
  watch: {
    newVerification () {
      if (this.newVerification) {
        this.mainBody.violationData.statoVerifica = null
        this.mainBody.verification.stato = null
        this.itemChanged = false
      }
    },
    'mainBody.verification.dataInizio': {
      handler: function () {
        if (this.currentTab === this.tabs.verification.index) {
          if (!isNil(this.mainBody.verification.dataInizio && !isNil(this.mainBody.verification.dataFine))) {
            const newFilterStart = new Date(this.mainBody.verification.detectedPosition.date)
            if (!isNil(this.mainBody.verification.dataInizio) && this.mainBody.verification.dataInizio.length > 0) {
              newFilterStart.setHours(this.mainBody.verification.dataInizio.split(':')[0],
                this.mainBody.verification.dataInizio.split(':')[1],
                this.mainBody.verification.dataInizio.split(':')[2])
            }
            const newFilterEnd = new Date(this.mainBody.verification.detectedPosition.date)
            if (!isNil(this.mainBody.verification.dataFine) && this.mainBody.verification.dataFine.length > 0) {
              newFilterEnd.setHours(this.mainBody.verification.dataFine.split(':')[0],
                this.mainBody.verification.dataFine.split(':')[1],
                this.mainBody.verification.dataFine.split(':')[2])
            }
            this.warningRange = newFilterStart.getTime() > newFilterEnd.getTime()
            this.filterStart = newFilterStart.toLocaleTimeString()
            this.filterStartMap = newFilterStart.getTime()
          }
        }
      },
      deep: true
    },
    'mainBody.verification.dataFine': {
      handler: function () {
        if (this.currentTab === this.tabs.verification.index) {
          if (!isNil(this.mainBody.verification.dataInizio && !isNil(this.mainBody.verification.dataFine))) {
            const newFilterEnd = new Date(this.mainBody.verification.detectedPosition.date)
            if (!isNil(this.mainBody.verification.dataFine) && this.mainBody.verification.dataFine.length > 0) {
              newFilterEnd.setHours(this.mainBody.verification.dataFine.split(':')[0],
                this.mainBody.verification.dataFine.split(':')[1],
                this.mainBody.verification.dataFine.split(':')[2])
            }
            const newFilterStart = new Date(this.mainBody.verification.detectedPosition.date)
            if (!isNil(this.mainBody.verification.dataFine) && this.mainBody.verification.dataInizio.length > 0) {
              newFilterStart.setHours(this.mainBody.verification.dataInizio.split(':')[0],
                this.mainBody.verification.dataInizio.split(':')[1],
                this.mainBody.verification.dataInizio.split(':')[2])
            }
            this.warningRange = newFilterStart.getTime() > newFilterEnd.getTime()
            this.filterEnd = newFilterEnd.toLocaleTimeString()
            this.filterEndMap = newFilterEnd.getTime()
          }
        }
      },
      deep: true
    },
    currentTab (newVal, oldVal) {
      this.oldTabIndex = oldVal
      this.newTabIndex = newVal
      if (!this.saveCheckModalIsActive) {
        this.checkTab(oldVal, newVal)
      } else {
        this.saveCheckModalIsActive = false
      }
    },
    'mainBody.verification.detectedPosition.verificaManuale': {
      handler: function () {
        if (this.mainBody.verification.detectedPosition.verificaManuale) {
          this.disabledSave = false
        }
      }
    }
  },
  created () {
    this.getDrivers().then(() => {
      this.fetchData()
    })
  },
  beforeMount () {
    this.handleResize()
  },
  methods: {
    onChangeLinkedViolation () {
      if (this.currentTab === this.tabs.violationData.index) {
        if (isNil(this.originalLinkedViolationId) || this.originalLinkedViolationId !== this.mainBody.violationData.idViolazioneCollegata) {
          this.getViolation(this.mainBody.violationData.idViolazioneCollegata).then((result) => {
            this.mainBody.violationData.emessoDa = result.emessoDa
            this.mainBody.violationData.targa = result.targa
            const infringementDate = new Date(result.dataInfrazione)

            // violation data
            this.mainBody.violationData.dataInfrazione = this.convertUTCDateToLocalDate(infringementDate)
            this.mainBody.violationData.oraInfrazione = this.convertUTCDateToLocalDate(infringementDate)
            this.mainBody.violationData.localita = result.localita
            this.mainBody.violationData.indirizzo = result.indirizzo
          })
        }
      }
    },
    checkWindowWidth () {
      const size = Vue.myGetWindowSize()
      this.isMobile = (size !== 'md' && size !== 'lg' && size !== 'xl')
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
      this.isMobile = window.innerWidth < 767
    },
    async fetchData () {
      if (this.companyOptions.length === 0) {
        this.getCompany().then((result) => {
          this.companyOptions = result
        })
      }
      if (this.violationID) {
        await this.getViolation().then(() => {
          this.checkCategories()
        })
      }
      this.$root.$emit('activeLoader', true)
      this.getViolations().then((result) => {
        this.getMotivationOptions().then((motivationOptions) =>
          this.getOptions().then(() =>
            this.getVehicles().then(() =>
              this.getNotificationTemplates().then((notificationTemplates) =>
                this.getDisputeTemplates().then((disputeTemplates) => {
                  this.checkWatcher(true)
                  this.$root.$emit('activeLoader', false)

                  this.mainBody.violationData.id = this.violationID
                  this.mainBody.employeeNotification.numeroVerbale = this.mainBody.violationData.numeroVerbale
                  this.mainBody.dispute.numeroVerbale = this.mainBody.violationData.numeroVerbale

                  if (this.violationID) {
                    result.forEach((item) => {
                      if (item.value !== this.violationID) {
                        this.violationOptions.push(item)
                      }
                    })
                  } else {
                    this.violationOptions = result
                  }
                  this.violationOptions = this.violationOptions.sort(function (a, b) {
                    return a.value - b.value
                  })

                  this.notificationModelOptions = notificationTemplates
                  this.disputeModelOptions = disputeTemplates
                  this.motivationOptions = motivationOptions
                  const lastTabIndex = Vue.getLocalStorage('lastTabIndexPCN')
                  const violationID = this.violationID
                  const query = this.$route.query
                  if (!isNil(lastTabIndex) && lastTabIndex && lastTabIndex.violationID && lastTabIndex.violationID === violationID) {
                    this.changeTab(lastTabIndex.tabIndex, true)
                  } else {
                    if (query.tab) {
                      let foundedTab = {}
                      const tabs = keys(this.tabs)
                      tabs.forEach(tab => {
                        if (this.tabs[tab].name === query.tab) foundedTab = this.tabs[tab]
                      })
                      if (foundedTab && foundedTab.index) this.changeTab(foundedTab.index, true)
                    } else {
                      this.changeTab(0, true)
                    }
                    Vue.deleteLocalStorage('lastTabIndexPCN')
                  }
                })))))
      })
    },
    changeDate (selector, period, addition, reset) {
      if (reset) {
        const defaultStart = DateTime.local().set({
          minute: 0,
          second: 0,
          millisecond: 0
        })
        this.myDate = defaultStart.plus({ hours: -3 }).toISO()
        this.delayedStart = defaultStart.plus({ hours: -3 }).toMillis()
        this.delayedEnd = defaultStart.toMillis()
        this.hourRangeSelector = `${defaultStart.hour < 10 ? '0' + defaultStart.hour : defaultStart.hour}:00`
      } else {
        this[selector] = DateTime.fromISO(this[selector]).set({
          minute: 0,
          second: 0,
          millisecond: 0
        }).plus({ [period]: addition }).toISO()
      }
    },
    getViolations () {
      const session = Vue.getLocalStorage('session')
      const token = session && session.token
      const config = {
        method: 'get',
        url: this.BASE_URL_PENALTY_CHARGE_NOTICE + '/violazione',
        headers: {
          Authorization: 'Bearer ' + token
        }
      }

      return axios(config).then((response) => {
        const options = []
        response.data.risorse.forEach((item) => {
          options.push({
            value: item.id,
            text: item.id
          })
        })
        return options
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        return []
      })
    },
    checkCategories () {
      if (this.items.length === 0) {
        const config = {
          method: 'get',
          url: this.BASE_URL_AWDOC + '/categories?name=Violazioni',
          headers: this.headers
        }
        axiosRetry(axios, { retries: 1 })
        return axios(config)
          .then((violationCategory) => {
            if (violationCategory.data.length === 0) {
              config.url = this.BASE_URL_AWDOC + '/categories'
              config.method = 'post'
              config.data = {
                categories: [{
                  name: 'Violazioni',
                  type: Vue.getCategoryNumber('AUTOMANAGED'),
                  auto_name: 'Violazioni'
                }]
              }
              axios(config).then((newViolationCategory) => {
                this.violationCategoryUuid = first(newViolationCategory?.data?.categories)?.uuid
                config.method = 'get'
                config.url = this.BASE_URL_AWDOC + '/categories/{' + this.violationCategoryUuid + '}'

                axiosRetry(axios, { retries: 5 })
                axios(config)
                  .then(() => {
                    config.method = 'post'
                    config.url = this.BASE_URL_AWDOC + '/categories'
                    config.data = {
                      categories: [
                        {
                          name: 'ID',
                          type: Vue.getCategoryNumber('AUTOMANAGED'),
                          auto_name: 'Violazioni.ID',
                          parentUuid: this.violationCategoryUuid
                        },
                        {
                          name: 'Targhe',
                          type: Vue.getCategoryNumber('AUTOMANAGED'),
                          auto_name: 'Violazioni.Targhe',
                          parentUuid: this.violationCategoryUuid
                        },
                        {
                          name: 'Date',
                          type: Vue.getCategoryNumber('AUTOMANAGED'),
                          auto_name: 'Violazioni.Date',
                          parentUuid: this.violationCategoryUuid
                        },
                        {
                          name: 'RicevutePagamento',
                          type: Vue.getCategoryNumber('AUTOMANAGED'),
                          auto_name: 'Violazioni.RicevutePagamento',
                          parentUuid: this.violationCategoryUuid
                        }
                      ]
                    }

                    axios(config).then((response) => {
                      this.idCategoryUuid = response?.data?.categories[0]?.uuid
                      this.createCategory(this.mainBody.violationData.id, 'Violazioni.ID.' + this.mainBody.violationData.id, this.idCategoryUuid).then((result) => {
                        this.currentViolation.idUuid = result
                      })
                      this.plateCategoryUuid = response?.data?.categories[1]?.uuid
                      this.createCategory(this.mainBody.violationData.targa, 'Violazioni.Targhe.' + this.mainBody.violationData.targa, this.plateCategoryUuid).then((result) => {
                        this.currentViolation.plateUuid = result
                      })
                      this.dateCategoryUuid = response?.data?.categories[2]?.uuid
                      this.createCategory(this.directoryNamesDates[new Date(this.mainBody.violationData.dataVerbale).getMonth()], 'Violazioni.Date.' + this.directoryNamesDates[new Date(this.mainBody.violationData.dataVerbale).getMonth()], this.dateCategoryUuid).then((result) => {
                        this.currentViolation.monthUuid = result
                      })
                    })
                  })
              })
            } else {
              this.violationCategoryUuid = first(violationCategory?.data)?.uuid.substring(1, first(violationCategory?.data)?.uuid?.length - 1)
              axiosRetry(axios, { retries: 3 })
              this.getCategoryUuid('ID').then((result) => {
                this.idCategoryUuid = result
                this.getDocuments(result, this.mainBody.violationData.id, 'Violazioni.ID.').then((response) => {
                  this.currentViolation.idUuid = response.toString().substring(1, response.length - 1)
                })
              })
              this.getCategoryUuid('Targhe').then((result) => {
                this.getCategoryUuid(this.mainBody.violationData.targa, 'Violazioni.Targhe.', result).then((child) => {
                  this.currentViolation.plateUuid = child
                })
              })
              this.getCategoryUuid('Date').then((result) => {
                this.getCategoryUuid(this.directoryNamesDates[new Date(this.mainBody.violationData.dataVerbale).getMonth()], 'Violazioni.Date.', result).then((child) => {
                  this.currentViolation.monthUuid = child
                })
              })
              this.getCategoryUuid('RicevutePagamento').then((result) => {
                this.getCategoryUuid('RicevutePagamento', 'Violazioni.', result).then((child) => {
                  this.paymentReceiptsCategoryUuid = child
                })
              })
            }
          }).catch((error) => {
            this.$root.$emit('activeLoader', false)
            if (isNil(error.response) || error.response.status === 401 || error.response.status === 502 || error.response.status === 500) {
              this.awdocAuthenticated = false
              Vue.info(this, `${this.$tc('info.awdocAuthorized')}`)
            }
            return []
          })
      }
    },
    getCategoryUuid (categoryName, parentName, parentUuid) {
      const config = {
        method: 'get',
        url: this.BASE_URL_AWDOC + '/categories?name=' + categoryName,
        headers: this.headers
      }
      axiosRetry(axios, { retries: 3 })
      return axios(config)
        .then((category) => {
          if (category.data.length === 0) {
            return this.createCategory(categoryName, 'Violazioni.' + !isNil(parentName) ? parentName : '' + categoryName, parentUuid)
          } else {
            return first(category?.data)?.uuid.substring(1, first(category?.data)?.uuid?.length - 1)
          }
        }).catch((error) => {
          console.log(error)
          return -1
        })
    },
    createCategory (categoryName, autoName, parentUuid) {
      const config = {
        method: 'post',
        url: this.BASE_URL_AWDOC + '/categories',
        headers: this.headers,
        data: {
          categories: [{
            name: categoryName.toString(),
            type: Vue.getCategoryNumber('AUTOMANAGED'),
            auto_name: autoName,
            parentUuid: !isNil(parentUuid) ? parentUuid : this.violationCategoryUuid
          }]
        }
      }

      return axios(config)
        .then((newIdCategory) => {
          return first(newIdCategory?.data?.categories)?.uuid
        }).catch((error) => {
          console.log(error)
          return []
        })
    },
    getDocuments (parentUuid, lastCategoryChildName, parentName) {
      const config = {
        method: 'get',
        url: this.BASE_URL_AWDOC + '/categories?child_of={' + parentUuid + '}',
        headers: this.headers
      }
      return axios(config)
        .then((childCategories) => {
          axiosRetry(axios, { retries: 3 })
          if (childCategories?.data?.length === 0 || isNil(find(childCategories?.data, (item) => item.name === lastCategoryChildName.toString()))) {
            return this.createCategory(lastCategoryChildName, parentName + lastCategoryChildName, parentUuid)
          } else if (childCategories?.data?.length > 0 &&
                !isNil(find(childCategories?.data, (item) => item.name === this.mainBody.violationData.id.toString()))) {
            const uuid = find(childCategories?.data, (item) => item.name === lastCategoryChildName.toString()).uuid
            config.url = this.BASE_URL_AWDOC + '/categories/' + uuid + '/documents'
            return axios(config)
              .then((documentsList) => {
                config.url = this.BASE_URL_AWDOC + '/categories/{' + this.paymentReceiptsCategoryUuid + '}/documents'
                return axios(config)
                  .then((documentsReceipt) => {
                          // eslint-disable-next-line no-unused-expressions
                          documentsList?.data?.forEach((item) => {
                            item.valid_from = new Date(item.valid_from).toLocaleDateString()
                            if (!isNil(find(documentsReceipt.data, (document) => document.uuid === item.uuid))) {
                              item.document_type = 'Ricevuta pagamento'
                              this.itemsReceipt.push(item)
                            } else {
                              item.document_type = 'Allegato'
                            }
                            this.items.push(item)
                          })
                          return uuid
                  })
              })
          }
          return ''
        }).catch((error) => {
          Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        })
    },
    deleteDocument (item) {
      const uri = this.BASE_URL_AWDOC + '/documents/' + item.uuid.substring(1, item.uuid.length - 1)
      const config = {
        method: 'delete',
        url: uri,
        headers: this.headers
      }
      return axios(config)
        .then(() => {
          Vue.success(this, `${this.$t('success.fileDeleted')}`)
          this.$router.push({
            name: 'RefreshPage',
            params: {
              id: this.mainBody.violationData.id,
              name: 'EditPenaltyChargeNotice'
            },
            query: { tab: this.currentTab.name }
          })
        }).catch(() => {
          Vue.error(this, `${this.$t('errors.fileDeleted')}`)
          this.$router.push({
            name: 'RefreshPage',
            params: {
              id: this.mainBody.violationData.id,
              name: 'EditPenaltyChargeNotice'
            },
            query: { tab: this.currentTab.name }
          })
        })
    },
    downloadDocument (item) {
      const uri = this.BASE_URL_AWDOC + '/documents/' + item.uuid.substring(1, item.uuid.length - 1) + '/download'
      const config = {
        method: 'get',
        url: uri,
        headers: this.headers,
        responseType: 'blob'
      }
      return axios(config)
        .then((response) => {
          var blob = new Blob([response.data])
          this.saveData(blob, item.title)
        }).catch(() => {
          Vue.error(this, `${this.$t('errors.fileDownload')}`)
        })
    },
    saveData (blob, fileName) {
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.style = 'display: none'

      var url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = fileName
      a.click()
      window.URL.revokeObjectURL(url)
    },
    uploadDocument (file, categories) {
      if (!this.awdocAuthenticated) {
        Vue.info(this, `${this.$tc('info.awdocAuthorized')}`)
        this.resetDocuments()
      } else if (!this.isFileValid(file)) {
        Vue.error(this, `${this.$tc('errors.fileFormat')}`)
        this.resetDocuments()
      } else {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('title', file.name)
        formData.append('mime_type', file.type)
        formData.append('categories', categories)
        var config = {
          method: 'post',
          url: this.BASE_URL_AWDOC + '/documents',
          headers: this.headers,
          data: formData
        }
        delete config.data.Authorization
        this.$root.$emit('activeLoader', true)
        axios(config)
          .then((response) => {
            this.$root.$emit('activeLoader', false)
            Vue.success(this, `${this.$t('success.fileUpload')}`)
            this.$router.push({
              name: 'RefreshPage',
              params: {
                id: this.mainBody.violationData.id,
                name: 'EditPenaltyChargeNotice'
              },
              query: { tab: this.currentTab.name }
            })
          })
          .catch((error) => {
            console.log(error)
            this.$root.$emit('activeLoader', false)
            if (error.response.status === 401) {
              Vue.info(this, `${this.$tc('info.awdocAuthorized')}`)
            } else {
              Vue.error(this, `${this.$tc('errors.fileUpload')}`)
            }
            this.$router.push({
              name: 'RefreshPage',
              params: {
                id: this.mainBody.violationData.id,
                name: 'EditPenaltyChargeNotice'
              },
              query: { tab: this.currentTab.name }
            })
          })
      }
    },
    resetDocuments () {
      this.mainBody.payment.paymentReceipt = null
      this.mainBody.attachment.newDocument = null
      setTimeout(() => {
        this.disabledSave = true
        this.itemChanged = false
      }, 1000)
    },
    isNumber (evt, input, integerValue) {
      evt = (evt) || window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        if ((!integerValue && (charCode !== 46 || (!isNil(input) && input.toString().indexOf('.') !== -1))) || integerValue) {
          evt.preventDefault()
        }
      } else {
        return true
      }
    },
    getViolation (id) {
      const session = Vue.getLocalStorage('session')
      const token = session && session.token
      const config = {
        method: 'get',
        url: `${this.BASE_URL_PENALTY_CHARGE_NOTICE}/violazione/${id || this.violationID}`,
        headers: {
          Authorization: 'Bearer ' + token
        }
      }

      return axios(config).then((response) => {
        if (isNil(id)) {
          this.mainBody.violationData = response.data
          const infringementDate = new Date(this.mainBody.violationData.dataInfrazione)
          this.mainBody.violationData.oraInfrazione = infringementDate.toLocaleTimeString()
          // violation data
          this.originalLinkedViolationId = this.mainBody.violationData.idViolazioneCollegata
          this.mainBody.violationData.dataInfrazione = this.convertUTCDateToLocalDate(infringementDate)

          this.mainBody.violationData.dataVerbale = this.convertUTCDateToLocalDate(new Date(this.mainBody.violationData.dataVerbale))
          this.mainBody.violationData.scadenza = new Date(this.mainBody.violationData.scadenza).toISOString()
          this.mainBody.violationData.scadenzaRiduzione = new Date(this.mainBody.violationData.scadenzaRiduzione).toISOString()
          this.mainBody.verification.violationData.dataInfrazione = this.convertUTCDateToLocalDate(infringementDate)
          this.initialInfringementTime = this.mainBody.violationData.oraInfrazione

          // verification
          this.mainBody.verification.violationData.dataInfrazioneFormatted = DateTime.fromISO(infringementDate.toISOString()).toFormat(this.$tc('message.dateFormat', 1) + ' ' + this.$tc('message.timeFormat', 1))
          this.mainBody.verification.violationData.indirizzo = this.mainBody.violationData.indirizzo
          this.mainBody.verification.violationData.localita = this.mainBody.violationData.localita
          this.mainBody.verification.violationData.targa = this.mainBody.violationData.targa
          if (!isNil(this.mainBody.violationData.verifica)) {
            this.mainBody.verification.detectedPosition = this.mainBody.violationData.verifica
            this.mainBody.verification.stato = this.mainBody.violationData.verifica.stato
          }
          this.mainBody.verification.detectedPosition.date = this.mainBody.violationData.dataInfrazione
          this.mainBody.verification.responsabile = session.user.userName
          if (!isNil(find(this.allVehiclesWithObu, item => item.plateNumber === this.mainBody.verification.violationData.targa))) {
            this.mainBody.verification.detectedPosition.verificaManuale = true
            this.disableManualVerification = true
          }
          // employee notification
          if (!isNil(this.mainBody.violationData.rimborso)) {
            this.mainBody.employeeNotification = cloneDeep(this.mainBody.violationData.rimborso)
          }

          this.mainBody.employeeNotification.dataInvio = !isNil(this.mainBody.employeeNotification.dataInvio)
            ? new Date(this.mainBody.employeeNotification.dataInvio).getDate() +
              '/' + (new Date(this.mainBody.employeeNotification.dataInvio).getMonth() + 1).toString() + '/' +
              new Date(this.mainBody.employeeNotification.dataInvio).getFullYear() : null
          this.mainBody.employeeNotification.autista = this.mainBody.verification.detectedPosition.nomeAutista !== ''
            ? this.mainBody.verification.detectedPosition.nomeAutista : '- - -'
          if (this.mainBody.verification.detectedPosition.idAutista !== '') {
            const driver = find(this.drivers, (item) => item.id === this.mainBody.verification.detectedPosition.idAutista)
            this.mainBody.employeeNotification.idAutista = this.mainBody.verification.detectedPosition.idAutista
            this.mainBody.employeeNotification.autista = !isNil(driver)
              ? driver.surname + ' ' + driver.name : '- - -'
            this.mainBody.employeeNotification.email = !isNil(driver) && !isNil(driver.email)
              ? driver.email : '- - -'
            this.thisDriver.consensus = !isNil(driver) && !isNil(driver.consensus) ? driver.consensus : false
            this.thisDriver.exemption = !isNil(driver) && !isNil(driver.exemption) ? driver.exemption : false
          } else {
            this.mainBody.employeeNotification.idAutista = '- - -'
            this.mainBody.employeeNotification.email = '- - -'
          }

          // payment
          if (!isNil(this.mainBody.violationData.pagamento)) {
            this.mainBody.payment = this.mainBody.violationData.pagamento
          }
          this.mainBody.payment.stato = this.mainBody.violationData.statoPagamento
          this.mainBody.payment.data = this.mainBody.payment.data ? this.convertUTCDateToLocalDate(new Date(this.mainBody.payment.data)) : null
          // dispute
          if (!isNil(this.mainBody.violationData.contestazione)) {
            this.mainBody.dispute = this.mainBody.violationData.contestazione
          }
          this.mainBody.dispute.dataInvio = !isNil(this.mainBody.dispute.dataInvio)
            ? new Date(this.mainBody.dispute.dataInvio).getDate() +
              '/' + (new Date(this.mainBody.dispute.dataInvio).getMonth() + 1).toString() + '/' +
              new Date(this.mainBody.dispute.dataInvio).getFullYear() : null
          this.mainBody.dispute.dataScadenza = !isNil(this.mainBody.dispute.dataScadenza) ? this.convertUTCDateToLocalDate(new Date(this.mainBody.dispute.dataScadenza)) : null

          if (!isNil(this.mainBody.violationData.verifica.idAutista)) {
            this.newVerification = false
            if (!this.mainBody.violationData.verifica.verificaManuale) {
              this.getVerificationScreen()
            }
          }
          var timeBefore = infringementDate.getTime() - 300 * 1000
          var timeAfter = infringementDate.getTime() + 300 * 1000

          this.filterStart = new Date(new Date(new Date(this.mainBody.violationData.dataInfrazione).setTime(timeBefore))).toLocaleTimeString()
          this.filterEnd = new Date(new Date(new Date(this.mainBody.violationData.dataInfrazione).setTime(timeAfter))).toLocaleTimeString()
          this.filterStartMap = new Date(new Date(new Date(this.mainBody.violationData.dataInfrazione).setTime(timeBefore))).getTime()
          this.filterEndMap = new Date(new Date(new Date(this.mainBody.violationData.dataInfrazione).setTime(timeAfter))).getTime()
          this.mainBody.verification.dataInizio = this.filterStart
          this.mainBody.verification.dataFine = this.filterEnd
        }
        return response.data
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        this.itemChanged = false
        this.pushBack()
      })
    },
    convertUTCDateToLocalDate (date) {
      const newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000)

      const offset = date.getTimezoneOffset() / 60
      const hours = date.getHours()

      newDate.setHours(hours - offset)

      return newDate
    },
    savePenaltyChargeNotice (close) {
      if (this.currentTab === this.tabs.violationData.index) {
        this.saveViolationData(close)
      } else if (this.currentTab === this.tabs.verification.index) {
        this.saveVerification(null, close)
      } else if (this.currentTab === this.tabs.payment.index) {
        this.savePayment(close)
      } else if (this.currentTab === this.tabs.employeeNotification.index) {
        this.saveNotification(close)
      } else if (this.currentTab === this.tabs.dispute.index) {
        this.saveDispute(close)
      }
    },
    saveViolationData (close) {
      if (find(this.originalVehicles, item => item.plateNumber === this.mainBody.violationData.targa)) {
        const session = Vue.getLocalStorage('session')
        const token = session && session.token
        const infringementDate = new Date(this.mainBody.violationData.dataInfrazione)
        const verbalDate = new Date(this.mainBody.violationData.dataVerbale)
        if (verbalDate.getTime() === infringementDate.getTime()) {
          verbalDate.setHours(this.mainBody.violationData.oraInfrazione.split(':')[0], this.mainBody.violationData.oraInfrazione.split(':')[1], this.mainBody.violationData.oraInfrazione.split(':')[2] + 1)
          verbalDate.setTime(verbalDate.getTime() + verbalDate.getTimezoneOffset() * 60 * 1000)
        }
        infringementDate.setHours(this.mainBody.violationData.oraInfrazione.split(':')[0], this.mainBody.violationData.oraInfrazione.split(':')[1], this.mainBody.violationData.oraInfrazione.split(':')[2])
        //  infringementDate.setTime(infringementDate.getTime() + infringementDate.getTimezoneOffset() * 60 * 1000)
        const newPenaltyChargeNotice = {
          id: this.mainBody.violationData.id,
          numeroVerbale: this.mainBody.violationData.numeroVerbale,
          dataInfrazione: infringementDate,
          targa: this.mainBody.violationData.targa,
          importo: parseFloat(this.mainBody.violationData.importo),
          scadenza: new Date(this.mainBody.violationData.scadenza).toISOString().replace(/:00.000Z/, ':00Z'),
          importoRidotto: parseFloat(this.mainBody.violationData.importoRidotto),
          scadenzaRiduzione: new Date(this.mainBody.violationData.scadenzaRiduzione).toISOString().replace(/:00.000Z/, ':00Z'),
          idViolazioneCollegata: this.mainBody.violationData.idViolazioneCollegata !== null ? parseInt(this.mainBody.violationData.idViolazioneCollegata) : null,
          idMotivazioneInfrazione: this.mainBody.violationData.idMotivazioneInfrazione,
          dataVerbale: verbalDate,
          emessoDa: this.mainBody.violationData.emessoDa,
          localita: this.mainBody.violationData.localita,
          indirizzo: this.mainBody.violationData.indirizzo,
          puntiPatente: this.mainBody.violationData.puntiPatente !== null ? parseInt(this.mainBody.violationData.puntiPatente) : null
        }
        if (newPenaltyChargeNotice.idViolazioneCollegata === null) {
          delete newPenaltyChargeNotice.idViolazioneCollegata
        }
        if (newPenaltyChargeNotice.puntiPatente === null) {
          delete newPenaltyChargeNotice.puntiPatente
        }
        if (newPenaltyChargeNotice.emessoDa === null) {
          delete newPenaltyChargeNotice.emessoDa
        }
        const config = {
          headers: {
            Authorization: 'Bearer ' + token
          }
        }
        if (this.violationID === null) {
          return axios.post(`${this.BASE_URL_PENALTY_CHARGE_NOTICE}/violazione`, newPenaltyChargeNotice, config).then((response) => {
            Vue.success(this, `${this.$tc('message.penaltyChargeNotice', 1)} ${this.$t('success.postSuccess')}`)
            if (!close) {
              this.$router.push({
                name: 'RefreshPage',
                params: {
                  id: response.data.id,
                  name: 'EditPenaltyChargeNotice'
                },
                query: { tab: this.currentTab.name }
              })
            } else {
              this.itemChanged = false
              this.pushBack()
            }
          }).catch(error => {
            Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
            this.itemChanged = false
            this.pushBack()
          })
        } else {
          delete newPenaltyChargeNotice.id
          return axios.patch(`${this.BASE_URL_PENALTY_CHARGE_NOTICE}/violazione/${this.violationID}`, newPenaltyChargeNotice, config).then((response) => {
            Vue.success(this, `${this.$tc('message.penaltyChargeNotice', 1)} ${this.$t('success.putSuccess')}`)
            if (!close) {
              this.$router.push({
                name: 'RefreshPage',
                params: {
                  id: this.violationID,
                  name: 'EditPenaltyChargeNotice'
                },
                query: { tab: this.currentTab.name }
              })
            } else {
              this.itemChanged = false
              this.pushBack()
            }
          }).catch(error => {
            Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
            this.itemChanged = false
            this.pushBack()
          })
        }
      } else {
        Vue.error(this, 'Inserisci un numero di targa valido!')
      }
    },
    putVerification (verification) {
      const session = Vue.getLocalStorage('session')
      const token = session && session.token
      const newVerification = verification
      const start = this.mainBody.verification.dataInizio
      const end = this.mainBody.verification.dataFine
      newVerification.dataInizio = new Date(newVerification.date)
      newVerification.dataFine = new Date(newVerification.date)
      const driver = find(this.drivers, driver => driver.id === verification.idAutista)
      newVerification.nomeAutista = !isNil(driver) ? driver.name + ' ' + driver.surname : ''
      if (!this.mainBody.verification.detectedPosition.verificaManuale) {
        newVerification.dataInizio.setHours(start.split(':')[0], start.split(':')[1], start.split(':')[2])
        newVerification.dataInizio.setTime(newVerification.dataInizio.getTime() + newVerification.dataInizio.getTimezoneOffset() * 60 * 1000)
        newVerification.dataFine.setHours(end.split(':')[0], end.split(':')[1], end.split(':')[2])
        newVerification.dataFine.setTime(newVerification.dataFine.getTime() + newVerification.dataFine.getTimezoneOffset() * 60 * 1000)
      }
      newVerification.stato = this.mainBody.verification.stato
      if (newVerification.verificaManuale) {
        newVerification.idResponsabile = session.user.customerId
      }
      delete newVerification.date
      if (newVerification.stato === null) {
        newVerification.stato = 'DA_VERIFICARE'
      }
      const config = {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }

      return axios.put(`${this.BASE_URL_PENALTY_CHARGE_NOTICE}/verifica/${this.violationID}`, newVerification, config).then(() => {
        return Vue.myGet(this, `/drivers/${newVerification.idAutista}`, 'drivers').then((driver) => {
          this.thisDriver = first(driver)
          if (this.itemChanged && !newVerification.verificaManuale) {
            const formData = new FormData()
            formData.append('image', this.dataURLtoFile(this.positionImage))
            return axios.put(`${this.BASE_URL_PENALTY_CHARGE_NOTICE}/mappa-verifica/${this.violationID}`, formData, config).then(() => {
              Vue.success(this, `${this.$tc('message.penaltyChargeNotice', 1)} ${this.$t('success.putSuccess')}`)
              if (!this.close) {
                this.$router.push({
                  name: 'RefreshPage',
                  params: {
                    id: this.violationID,
                    name: 'EditPenaltyChargeNotice'
                  },
                  query: { tab: this.currentTab.name }
                })
              } else {
                this.itemChanged = false
                this.pushBack()
              }
            }).catch(error => {
              console.log(error)
              Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
              this.itemChanged = false
              this.pushBack()
            })
          } else {
            Vue.success(this, `${this.$tc('message.penaltyChargeNotice', 1)} ${this.$t('success.putSuccess')}`)
            if (!this.close) {
              this.$router.push({
                name: 'RefreshPage',
                params: {
                  id: this.violationID,
                  name: 'EditPenaltyChargeNotice'
                },
                query: { tab: this.currentTab.name }
              })
            } else {
              this.itemChanged = false
              this.pushBack()
            }
          }
          const newEmployeeNotification = {
            email: !isNil(first(driver).email) ? first(driver).email : ''
          }
          newEmployeeNotification.societa = !isNil(this.thisDriver.company) && this.thisDriver.company !== ''
            ? find(this.companyOptions, (item) => item.id === this.thisDriver.company).description : ''
          return axios.put(`${this.BASE_URL_PENALTY_CHARGE_NOTICE}/rimborso/${this.violationID}`, newEmployeeNotification, config).then(() => {
          }).catch(error => {
            Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
            this.itemChanged = false
            this.pushBack()
          })
        }).catch(error => {
          Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
          this.itemChanged = false
          return false
        })
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        this.itemChanged = false
        this.pushBack()
      })
    },
    dataURLtoFile (dataurl, filename) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n) {
        u8arr[n - 1] = bstr.charCodeAt(n - 1)
        n -= 1 // to make eslint happy
      }
      return new File([u8arr], filename, { type: mime })
    },
    savePayment (close) {
      const session = Vue.getLocalStorage('session')
      const token = session && session.token
      const newPayment = {
        importo: parseFloat(this.mainBody.payment.importo),
        data: new Date(this.mainBody.payment.data).toISOString().replace(/:00.000Z/, ':00Z'),
        metodo: this.mainBody.payment.metodo,
        stato: this.mainBody.payment.stato
      }

      const config = {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }

      return axios.put(`${this.BASE_URL_PENALTY_CHARGE_NOTICE}/pagamento/${this.violationID}`, newPayment, config).then((response) => {
        Vue.success(this, `${this.$tc('message.penaltyChargeNotice', 1)} ${this.$t('success.putSuccess')}`)
        if (!close) {
          this.$router.push({
            name: 'RefreshPage',
            params: {
              id: this.violationID,
              name: 'EditPenaltyChargeNotice'
            },
            query: { tab: this.currentTab.name }
          })
        } else {
          this.itemChanged = false
          this.pushBack()
        }
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        this.itemChanged = false
        this.pushBack()
      })
    },
    saveNotification (close) {
      if (this.mainBody.verification.stato === 'NON_ACCETTATA' ||
          this.mainBody.violationData.statoPagamento === 'NON_ESEGUITO' ||
          !this.thisDriver.consensus ||
          this.thisDriver.exemption) {
        this.$refs.warningNotificationNotSavable.show()
      } else {
        const session = Vue.getLocalStorage('session')
        const token = session && session.token
        const body = this.mainBody.employeeNotification
        if (!isNil(body.emailSecondaria) && body.emailSecondaria.length === 0) {
          body.emailSecondaria = null
        }
        if (!isNil(body.emailAmministrazione) && body.emailAmministrazione.length === 0) {
          body.emailAmministrazione = null
        }
        const config = {
          headers: {
            Authorization: 'Bearer ' + token
          }
        }

        return axios.put(`${this.BASE_URL_PENALTY_CHARGE_NOTICE}/rimborso/${this.violationID}`, body, config).then((response) => {
          Vue.success(this, `${this.$tc('message.penaltyChargeNotice', 1)} ${this.$t('success.putSuccess')}`)
          if (!close) {
            this.$router.push({
              name: 'RefreshPage',
              params: {
                id: this.violationID,
                name: 'EditPenaltyChargeNotice'
              },
              query: { tab: this.currentTab.name }
            })
          } else {
            this.itemChanged = false
            this.pushBack()
          }
        }).catch(error => {
          Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
          this.itemChanged = false
          this.pushBack()
        })
      }
    },
    saveDispute (close) {
      if (this.mainBody.verification.stato === 'ACCETTATA') {
        this.$refs.warningDisputeNotSavable.show()
      } else {
        const session = Vue.getLocalStorage('session')
        const token = session && session.token
        const body = this.mainBody.dispute
        body.dataScadenza = !isNil(body.dataScadenza) ? new Date(body.dataScadenza) : null
        const config = {
          headers: {
            Authorization: 'Bearer ' + token
          }
        }

        return axios.put(`${this.BASE_URL_PENALTY_CHARGE_NOTICE}/contestazione/${this.violationID}`, body, config).then((response) => {
          Vue.success(this, `${this.$tc('message.penaltyChargeNotice', 1)} ${this.$t('success.putSuccess')}`)
          if (!close) {
            this.$router.push({
              name: 'RefreshPage',
              params: {
                id: this.violationID,
                name: 'EditPenaltyChargeNotice'
              },
              query: { tab: this.currentTab.name }
            })
          } else {
            this.itemChanged = false
            this.pushBack()
          }
        }).catch(error => {
          Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
          this.itemChanged = false
          this.pushBack()
        })
      }
    },
    checkTab (oldTabIndex, newTabIndex) {
      const oldTab = find(this.tabs, obj => obj.index === oldTabIndex)
      const newTab = find(this.tabs, obj => obj.index === newTabIndex)
      if (this.itemChanged) {
        if (oldTab) oldTab.active = true
        if (newTab) newTab.active = false
        this.saveCheck()
      } else {
        if (oldTab) oldTab.active = false
        if (newTab) newTab.active = true
        this.transitionName = oldTabIndex > newTabIndex ? 'slide-right' : 'slide-left'
        this.changeTab(newTab.index, true)
      }
      Vue.setLocalStorage('lastTabIndexPCN', {
        violationID: this.violationID,
        tabIndex: this.itemChanged ? oldTabIndex : newTabIndex
      })
    },
    saveCheck () {
      this.$refs.saveCheckModal.show()
    },
    hideSaveCheckModal (isNew) {
      this.$refs.saveCheckModal.hide()
      if (this.switchToLinkedViolation && (isNew || isNew === 0)) {
        this.$router.push({
          name: 'RefreshPage',
          params: {
            id: this.mainBody.violationData.idViolazioneCollegata,
            name: 'EditPenaltyChargeNotice'
          },
          query: { tab: this.currentTab.name }
        })
      } else if (!this.switchToLinkedViolation) {
        this.itemChanged = false
        this.disabledSave = true
        const index = isNew ? this.newTabIndex : this.oldTabIndex

        Vue.deleteLocalStorage('lastIndexPCN')
        this.checkWatcher(isNew)
        Vue.setLocalStorage('lastTabIndexPCN', {
          violationID: this.violationID,
          tabIndex: index
        })
        if (isNew || isNew === 0) {
          this.fetchData()
        } else {
          this.saveCheckModalIsActive = true
          this.changeTab(index)
          this.position = null
        }
      }
    },
    changeTab (newIndex, triggerReset) {
      this.checkWatcher(triggerReset)
      const newTab = find(this.tabs, obj => obj.index === newIndex)
      this.warningRange = false
      if (this.position) {
        this.position = null
      }
      if (newTab) newTab.active = true
      Vue.deleteLocalStorage('lastIndexPCN')
      Vue.setLocalStorage('lastTabIndexPCN', {
        violationID: this.violationID,
        tabIndex: newIndex
      })
      if (newIndex || newIndex === 0) this.currentTab = newIndex
      if (this.$refs.saveCheckModal) {
        this.$refs.saveCheckModal.hide()
      }
      this.disabledSave = true
      this.addWatcher()
    },
    addWatcher () {
      this.violationDataWatcher = this.$watch('mainBody.violationData', () => {
        this.itemChanged = true
        this.checkDisableSaveViolationData()
      }, { deep: true })
      this.attachmentWatcher = this.$watch('mainBody.attachment', () => {
        this.itemChanged = true
      }, { deep: true })
      this.verificationWatcher = this.$watch('mainBody.verification', () => {
        if (this.mainBody.verification.stato !== null && this.mainBody.verification.detectedPosition.idAutista !== null) {
          this.disabledSave = false
        }
      }, { deep: true })
      this.paymentWatcher = this.$watch('mainBody.payment', () => {
        if (isNil(this.mainBody.payment.paymentReceipt)) {
          this.itemChanged = true
          this.disabledSave = false
        }
      }, { deep: true })
      this.employeeNotificationWatcher = this.$watch('mainBody.employeeNotification', () => {
        if (!isNil(this.mainBody.employeeNotification.idTemplate)) {
          this.itemChanged = true
          this.disabledSave = false
        }
      }, { deep: true })
      this.disputeWatcher = this.$watch('mainBody.dispute', () => {
        if (!isNil(this.mainBody.dispute.idTemplate)) {
          this.itemChanged = true
          this.disabledSave = false
        }
      }, { deep: true })
      this.$root.$emit('activeLoader', false)
    },
    checkDisableSaveViolationData () {
      if (this.currentTab === this.tabs.violationData.index) {
        if (this.mainBody.violationData.dataVerbale !== null) {
          this.infringementDateConfig.maxDate = this.mainBody.violationData.dataVerbale
        }
        if (this.mainBody.violationData.dataInfrazione !== null) {
          this.verbalDateConfig.minDate = this.mainBody.violationData.dataInfrazione
        }
        this.disabledSave = !(this.mainBody.violationData.dataVerbale !== null &&
            this.mainBody.violationData.numeroVerbale !== null &&
            this.mainBody.violationData.targa !== null &&
            this.mainBody.violationData.dataInfrazione !== null &&
            this.mainBody.violationData.oraInfrazione !== null &&
            this.mainBody.violationData.localita !== null &&
            this.mainBody.violationData.indirizzo !== null &&
            this.mainBody.violationData.importo !== null &&
            this.mainBody.violationData.scadenza !== null &&
            this.mainBody.violationData.importoRidotto !== null &&
            this.mainBody.violationData.scadenzaRiduzione !== null &&
            this.mainBody.violationData.emessoDa !== null &&
            this.mainBody.violationData.idMotivazioneInfrazione !== null &&
            this.mainBody.violationData.puntiPatente !== null &&
            this.mainBody.violationData.dataVerbale !== '' &&
            this.mainBody.violationData.numeroVerbale !== '' &&
            this.mainBody.violationData.targa !== '' &&
            this.mainBody.violationData.dataInfrazione !== '' &&
            this.mainBody.violationData.oraInfrazione !== '' &&
            this.mainBody.violationData.localita !== '' &&
            this.mainBody.violationData.indirizzo !== '' &&
            this.mainBody.violationData.importo !== '' &&
            this.mainBody.violationData.scadenza !== '' &&
            this.mainBody.violationData.importoRidotto !== '' &&
            this.mainBody.violationData.scadenzaRiduzione !== '' &&
            this.mainBody.violationData.emessoDa !== '' &&
            this.mainBody.violationData.idMotivazioneInfrazione !== '' &&
            this.mainBody.violationData.puntiPatente !== ''
        ) || !this.itemChanged
      }
    },
    checkWatcher (reset) {
      this.$root.$emit('activeLoader', true)
      if (this.violationDataWatcher) this.violationDataWatcher()
      if (this.attachmentWatcher) this.attachmentWatcher()
      if (this.verificationWatcher) this.verificationWatcher()
      if (this.paymentWatcher) this.paymentWatcher()
      if (this.employeeNotificationWatcher) this.employeeNotificationWatcher()
      if (this.disputeWatcher) this.disputeWatcher()
      if (reset) this.itemChanged = false
    },
    pushBack (obj) {
      const backObj = obj || { name: 'PenaltyChargeNotice' }
      if (this.itemChanged) {
        this.$root.$emit('go-back-modal', backObj)
      } else {
        this.$router.push(backObj)
      }
      this.itemChanged = false
    },
    clickPosition (position, marker) {
      if (position) this.position = this.getPositionData(position)
      if (position && marker) {
        marker.bindPopup(this.$refs.popup.$el, {
          maxWidth: 310,
          minWidth: 200
        }).openPopup()
      }
      this.checkPosition()
    },
    loadedHistoryPosition () {
      this.setLoadedItemsTimeout()
    },
    setLoadedItemsTimeout () {
      this.loadedItemsTimeout = DateTime.local().ts + 2500
      this.$root.$emit('activeLoader', false)
      setTimeout(() => {
        const now = DateTime.local().ts
        const positions = this.$refs.staticMap && this.$refs.staticMap.historyPositions && this.$refs.staticMap.historyPositions.length
        const timerExpired = now - this.loadedItemsTimeout >= 0
        if (timerExpired) {
          if (positions === 0) Vue.info(this, this.$tc('info.emptyPositions'))
        }
      }, 2500)
    },
    mapError () {
      this.$root.$emit('activeLoader', false)
    },
    redirect (link) {
      if (link.href) this.$router.push(link.href)
    },
    getPositionData (position) {
      const foundedVehicle = find(this.allVehiclesWithObu, obj => obj.id === position.properties.vehicleId)
      const foundedDriver = find(this.allDrivers, obj => obj && obj.id === position.properties.driverId)
      const foundedTracker = find(this.allTrackers, obj => obj.imei === position.properties.imei)

      return {
        vehicle: foundedVehicle || null,
        driver: foundedDriver || null,
        tracker: foundedTracker || null,
        extraData: position
      }
    },
    getVehicles () {
      return Vue.myGet(this, '/vehicles', 'vehicles').then((vehicles) => {
        this.originalVehicles = [{
          id: '',
          imei: true,
          plateNumber: vehicles && vehicles.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption')
        }]
        const orderedItems = orderBy(vehicles, 'plateNumber')
        orderedItems.forEach((vehicle) => {
          this.originalVehicles.push(vehicle)
        })
        this.updateAllVehicles()
        return vehicles
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        return false
      })
    },
    updateAllVehicles () {
      const originalItems = cloneDeep(this.originalVehicles)
      const editedItems = []
      originalItems.forEach(item => {
        if (item.imei && !item.resignDate) {
          editedItems.push(item)
        }
      })
      const hasItems = editedItems.length !== 0 && editedItems.length !== 1
      this.allVehiclesWithObu = editedItems
      const plate = editedItems.find(item => item.plateNumber === this.mainBody.verification.violationData.targa)
      if (plate) {
        this.vehicleSelected = hasItems && plate ? plate.id : ''
      }
    },
    updateDrivers (realtime) {
      const originalItems = cloneDeep(this.originalDrivers)
      const editedItems = []
      if (!realtime) {
        this.allDrivers = originalItems
      } else {
        originalItems.forEach(item => {
          if (item.keyCode) {
            editedItems.push(item)
          }
        })
        this.allDrivers = editedItems
      }
      this.driverSelected = ''
    },
    getOptions () {
      const axiosArray = []
      axiosArray.push(this.getAllDrivers())
      axiosArray.push(this.getAllTrackers())
      return Vue.myAll(axiosArray).then(r => r)
    },
    getAllDrivers () {
      return Vue.myGet(this, '/drivers', 'drivers').then((drivers) => {
        const editedDrivers = [{
          editedName: this.$t('message.selectOption'),
          text: this.$t('message.selectOption'),
          id: '',
          keyCode: true
        }]
        const orderedItems = orderBy(drivers, ['surname', 'name'])
        orderedItems.forEach(driver => {
          const editedDriver = driver
          editedDriver.editedName = `${driver.surname} ${driver.name} - ${driver.taxCode}`
          editedDrivers.push(editedDriver)
        })
        this.originalDrivers = editedDrivers
        this.updateDrivers(true)
        this.driverSelected = ''
        return editedDrivers
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        return false
      })
    },
    getAllTrackers () {
      return Vue.myGet(this, '/trackers', 'trackers').then((trackers) => {
        this.allTrackers = trackers
        return trackers
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        return false
      })
    },
    checkPosition () {
      this.thisDriver = this.position.driver
      this.mainBody.verification.detectedPosition.targa = this.position.vehicle ? this.position.vehicle.plateNumber : ''
      this.mainBody.verification.detectedPosition.date = new Date(this.mainBody.verification.violationData.dataInfrazione)
      this.mainBody.verification.detectedPosition.idAutista = this.position.driver ? this.position.driver.id : ''
      this.mainBody.verification.detectedPosition.email = this.position.driver ? this.position.driver.email : ''
      this.mainBody.verification.detectedPosition.nomeAutista = this.position.driver ? this.position.driver.name + ' ' + this.position.driver.surname : ''
      this.mainBody.verification.detectedPosition.marca = this.position.vehicle && this.position.vehicle.type ? this.position.vehicle.type.brand : ''
      this.mainBody.verification.detectedPosition.modello = this.position.vehicle && this.position.vehicle.type ? this.position.vehicle.type.model : ''
      this.mainBody.verification.detectedPosition.motore = this.position.extraData.properties.events.engineStatus ? 'On' : 'Off'
      this.mainBody.verification.detectedPosition.velocita = this.position.extraData.properties.events.gpsSpeed ? this.position.extraData.properties.events.gpsSpeed : 0
      this.disabledSave = false
      this.itemChanged = true
    },
    saveVerification (image, close) {
      this.close = close
      if (image) {
        this.positionImage = image
      } else if (!this.mainBody.verification.detectedPosition.verificaManuale) {
        this.$refs.staticMap.takeScreenshot()
        return
      }
      this.$refs.chooseState.show()
    },
    getVerificationScreen () {
      const session = Vue.getLocalStorage('session')
      const token = session && session.token
      const config = {
        headers: {
          Authorization: 'Bearer ' + token
        },
        responseType: 'blob'
      }

      return axios.get(`${this.BASE_URL_PENALTY_CHARGE_NOTICE}/mappa-verifica/${this.violationID}`, config)
        .then((response) => {
          this.image = window.URL
            .createObjectURL(new Blob([response.data]))
        }).catch(error => {
          Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        })
    },
    reopenVerification () {
      if (isNil(this.mainBody.dispute.dataInvio) && isNil(this.mainBody.employeeNotification.dataInvio)) {
        this.newVerification = true
      } else {
        this.$refs.warningVerificationNotReopenable.show()
      }
    },
    deletePenaltyChargeNotice () {
      const session = Vue.getLocalStorage('session')
      const token = session && session.token
      const config = {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }

      return axios.delete(`${this.BASE_URL_PENALTY_CHARGE_NOTICE}/violazione/${this.violationID}`, config)
        .then((response) => {
          Vue.success(this, `${this.$tc('message.deleting')} ${this.$tc('message.done', 2).toLowerCase()}`)
          this.pushBack()
          this.$root.$emit('activeLoader', false)
        }).catch(error => {
          Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        })
    },
    getNotificationTemplates () {
      const session = Vue.getLocalStorage('session')
      const token = session && session.token
      const config = {
        method: 'get',
        url: this.BASE_URL_PENALTY_CHARGE_NOTICE + '/template/rimborso',
        headers: {
          Authorization: 'Bearer ' + token
        }
      }

      return axios(config).then((response) => {
        const options = []
        response.data.templates.forEach((item) => {
          options.push({
            value: item.nome,
            text: item.nome
          })
        })
        return options
      }).catch(error => {
        Vue.manageErrors(this, error)
        return []
      })
    },
    getDisputeTemplates () {
      const session = Vue.getLocalStorage('session')
      const token = session && session.token
      const config = {
        method: 'get',
        url: this.BASE_URL_PENALTY_CHARGE_NOTICE + '/template/contestazione',
        headers: {
          Authorization: 'Bearer ' + token
        }
      }

      return axios(config).then((response) => {
        const options = []
        response.data.templates.forEach((item) => {
          options.push({
            value: item.nome,
            text: item.nome
          })
        })
        this.mainBody.dispute.idTemplate = first(options).value
        return options
      }).catch(error => {
        Vue.manageErrors(this, error)
        return []
      })
    },
    getDrivers () {
      return Vue.myGet(this, '/drivers', 'drivers').then((drivers) => {
        const detailedDrivers = []
        detailedDrivers.push({
          value: null,
          text: drivers.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption')
        })

        drivers.forEach(driver => {
          detailedDrivers.push({
            text: `${driver.surname} ${driver.name} - ${driver.taxCode}`,
            value: driver.id
          })
        })
        this.driverOptions = detailedDrivers
        this.drivers = drivers
        return drivers
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        return false
      })
    },
    editLinkedViolation () {
      if (this.itemChanged) {
        this.switchToLinkedViolation = true
        this.$refs.saveCheckModal.show()
      } else {
        this.$router.push({
          name: 'RefreshPage',
          params: {
            id: this.mainBody.violationData.idViolazioneCollegata,
            name: 'EditPenaltyChargeNotice'
          },
          query: { tab: this.currentTab.name }
        })
      }
    },
    getMotivationOptions () {
      const session = Vue.getLocalStorage('session')
      const token = session && session.token
      const config = {
        method: 'get',
        url: this.BASE_URL_PENALTY_CHARGE_NOTICE + '/motivazione-infrazione',
        headers: {
          Authorization: 'Bearer ' + token
        }
      }

      return axios(config).then((response) => {
        const options = []
        response.data.risorse.forEach((item) => {
          options.push({
            value: item.id,
            text: item.descrizione
          })
        })
        return options
      }).catch(error => {
        Vue.manageErrors(this, error)
        return []
      })
    },
    sendEmployeeNotification () {
      const session = Vue.getLocalStorage('session')
      const token = session && session.token
      const config = {
        method: 'post',
        url: `${this.BASE_URL_PENALTY_CHARGE_NOTICE}/invia-rimborso/${this.violationID}`,
        headers: {
          Authorization: 'Bearer ' + token
        }
      }
      this.$root.$emit('activeLoader', true)
      return axios(config).then(() => {
        Vue.success(this, `${this.$tc('message.employeeNotification', 1)} ${this.$t('success.sendMail')}`)
        this.$router.push({
          name: 'RefreshPage',
          params: {
            id: this.violationID,
            name: 'EditPenaltyChargeNotice'
          },
          query: { tab: this.currentTab.name }
        })
        this.$root.$emit('activeLoader', false)
      }).catch(error => {
        console.log(error)
        this.$root.$emit('activeLoader', false)
        if (!isNil(error) && !isNil(error.data) && !isNil(error.data.message) && error.data.message.includes('Template')) {

        }
        Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        this.itemChanged = false
        this.pushBack()
      })
    },
    sendDisputeNotification () {
      const session = Vue.getLocalStorage('session')
      const token = session && session.token
      const config = {
        method: 'post',
        url: `${this.BASE_URL_PENALTY_CHARGE_NOTICE}/invia-contestazione/${this.violationID}`,
        headers: {
          Authorization: 'Bearer ' + token
        }
      }
      this.$root.$emit('activeLoader', true)
      return axios(config).then(() => {
        Vue.success(this, `${this.$tc('message.dispute', 1)} ${this.$t('success.sendMail')}`)
        this.$router.push({
          name: 'RefreshPage',
          params: {
            id: this.violationID,
            name: 'EditPenaltyChargeNotice'
          },
          query: { tab: this.currentTab.name }
        })
        this.$root.$emit('activeLoader', false)
      }).catch(error => {
        console.log(error)
        this.$root.$emit('activeLoader', false)
        Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        this.itemChanged = false
        this.pushBack()
      })
    },
    isDefined (field) {
      return !isNil(field) && field !== ''
    },
    isFileValid (file) {
      const res = file.name.match(/^.+\.(([pP][dD][fF])|([jJ][pP][gG])|([jJ][pP][eE][gG])|([pP][nN][gG]))$/g)
      return res != null
    },
    getCompany () {
      const options = []

      return Vue.myGet(this, '/enums/company', 'data').then((items) => {
        items.forEach((item) => {
          options.push({ id: item.id, description: item.descr })
        })
        return options
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    }
  }
}
</script>

<style scoped>
.c-grey, .my-color {
  color: darkgrey;
}

.c-b-green {
  background-color: #249a80 !important;
}

.c-b-grey {
  background-color: darkgrey;
}

.c-green {
  color: #249a80 !important;
}

svg {
  vertical-align: top;
}

.bold-text {
  font-weight: bold;
  font-size: 18px;
}

.bold-text-14 {
  font-weight: bold;
  font-size: 14px;
}

.first-table-cols > th:nth-child(1) {
  width: 10rem;
}

#verification-status > .card-body {
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
}

.invisible-button {
  background-color: white;
  border: none;
}

.my-map {
  width: 100%;
  display: flex !important;
}

.my-map > div {
  flex: 1 1 auto;
  display: flex;
  height: auto;
}

.main-container {
  display: flex;
  flex-flow: column;
}

.counter-container {
}

.all-content {
  display: flex;
  align-items: stretch;
  flex-grow: 1;
}

.view-container {
  width: 100%;
  display: flex;
  align-items: stretch;
}

.map-container {
  display: flex;
  flex-grow: 1;
}

.c-red {
  color: red !important;
}
</style>
